// This file is auto-generated by @hey-api/openapi-ts

export enum AccessLevel {
  READ = 0,
  WRITE = 1,
}

export enum AccessRole {
  FULLACCESS = 0,
  INVESTOR = 1,
  PUBLIC = 2,
  CAP_TABLE = 3,
  FUNDING_ROUND = 4,
  SHARE_CLASS = 5,
  VALUATION = 6,
  AUTHORIZATION = 7,
  DEBT = 8,
  OPTION = 9,
  PHANTOM_SHARE = 10,
  SHARE = 11,
  SHARE_GRANT = 12,
  WARRANT = 13,
  DOCUMENT = 15,
  NEWS = 17,
  PORTFOLIO = 18,
  SETTINGS = 19,
  OPTION_TRANSACTION_SET = 22,
  PHANTOM_SHARE_TRANSACTION_SET = 23,
  SHARE_TRANSACTION_SET = 24,
  SHARE_GRANT_TRANSACTION_SET = 25,
  WARRANT_TRANSACTION_SET = 26,
  DEBT_TRANSACTION_SET = 27,
  FILING = 28,
  DOCUMENT_SET = 31,
  SIGNING = 32,
  MESSAGE = 34,
  SHARE_CERTIFICATE = 35,
  SHARE_ADJUSTMENT = 36,
  CONVERSION_APPROVING = 37,
  RSU = 38,
  RSU_TRANSACTION_SET = 39,
  STAKEHOLDER = 40,
  SECONDARY_APPROVING = 41,
  PORTFOLIO_NEWS_EMAIL = 44,
  PORTFOLIO_FUNDING = 45,
  PORTFOLIO_ACCEPTOR = 46,
  SECURITIES_APPROVAL = 47,
}

export interface Account {
  account_status: AccountStatus
  account_status_reason: AccountStatusReason
  account_type: AccountType
  actor_verifications: ActorVerification[]
  juridical_person_category: JuridicalPersonCategory
  last_admin_action?: LastAdminAction
  stakeholders: AccountStakeholder[]
  unlinked_stakeholders: AccountStakeholder[]
  config_onboarding_type: OnboardingType
  id: number
  company_name: string
  registration_number: string
  country: string
  stripe_id: string
  billing_email: string
  partner_code: string
  billing_customer_id: number
  implementation_manager_id: number
  implementation_manager_name: string
  is_demo: boolean
  expiration_date?: string
  is_holding_company: boolean
  capdesk_client_url: string
  stripe_url: string
  config_enable_security_acceptance_flow: boolean
  config_enable_equity_management: boolean
  stripe_client_url: string
}

export interface AccountStakeholder {
  stakeholderable: Stakeholderable
  id: number
}

export enum AccountStatus {
  ACTIVE = 10,
  NOT_LIVE = 20,
  CLOSED = 80,
  DELETED = 90,
}

export enum AccountStatusReason {
  COMPANY_CREATION = 1,
  TERMS_ACCEPTED_BY_ADMIN = 4,
  ACTIVE_APP = 10,
  ACTIVE_REOPEN_BY_ADMIN = 11,
  NOT_LIVE_REOPEN_BY_ADMIN = 12,
  NOT_LIVE_APP_DEFAULT = 20,
  COMPANY_CLOSED_WHEN_ACQUIRED = 80,
  COMPANY_CLOSED_WHEN_MIGRATED_TO_CW = 81,
  DELETED_MANUAL_COMPANY_SETUP_ERROR = 90,
  DELETED_MANUAL_NOT_A_REAL_COMPANY = 91,
  DELETED_APP_LAST_ADMIN_CLOSES_ACCOUNT = 92,
  DELETED_APP_LAST_ADMIN_DELETED_SECONDARY_EMAIL = 93,
  DELETED_APP_CAPDESK_ADMINISTRATOR = 95,
  DELETED_APP_CANCEL_ORDER = 96,
  DELETED_COMPANY_CHURNED = 97,
  DELETED_COMPANY_MERGED = 98,
}

export enum AccountType {
  OPERATING = 0,
  INVESTING = 1,
  VEHICLE = 2,
  TEMPLATE = 3,
  DEMO = 4,
}

export enum AccrualMethod {
  CONTINUOUS = 0,
  BY_COMPOUNDING_PERIOD = 1,
}

export enum ActorPartyType {
  ISSUER = 'Actor::Party::Issuer',
  STAKEHOLDER = 'Actor::Party::Stakeholder',
  WITNESS = 'Actor::Party::Witness',
}

export interface ActorVerification {
  expires: string
  created_at?: string
  status?: VerificationStatus
  email?: string
}

export interface AddShareRegistersFilterValues {
  share_class_name?: unknown
  name_or_bkey?: string
  transactioned?: string
  transactioned_after?: string
}

export enum AdjustmentType {
  SUBDIVISION = 0,
  CONSOLIDATION = 1,
}

export interface AdminAction {
  status: AdminActionStatus
  reason: AdminActionReason
  documents: Document[]
  action_date: string
  company_id: number
  data: Record<string, unknown>
  id: number
  type: string
  billing_customer_id: number | null
  description: string | null
  stripe_id: number | null
  stripe_class: string | null
}

export enum AdminActionReason {
  IPO = 1,
  ACQUISITION = 2,
  COMPANY_SHUT_DOWN = 3,
  BUDGET = 4,
  PRODUCT_FIT = 5,
  CUSTOMER_FIT = 6,
  UNENGAGED = 7,
  POOR_ACCOUNT_MANAGEMENT = 8,
  COMPETITOR = 9,
  CAPDESK_ADMIN_ERROR = 10,
  CARTA_CHURN = 11,
  NEW_SALES_CHURN = 12,
  UNKNOWN = 13,
}

export enum AdminActionStatus {
  SCHEDULED = 1,
  COMPLETED = 2,
  FAILED = 3,
  CANCELLED = 4,
}

export enum AdministratorRole {
  CEO = 0,
  COO = 1,
  LEGAL = 2,
  FINANCE = 3,
  HUMAN_RESOURCES = 4,
  OTHER = 5,
  DEMO = 6,
  CAPDESK_STAFF = 10,
}

export interface AdoptParams {
  shareholder_date_adopted: string
  shareholder_resolution_category: ShareholderResolutionCategory
  shareholder_documents_attributes: DocumentsAttributes
  board_date_adopted: string
  board_resolution_category: BoardResolutionCategory
  board_documents_attributes: DocumentsAttributes
  authorized: string | null
}

export enum AdvanceAssuranceHmrcResolution {
  REJECTED = 0,
  APPROVED = 1,
}

export interface AdvanceAssuranceRequest {
  application_documents_package_id: number
  cancellation_reason: string | null
  cancelled_at: string | null
  completed_at: string | null
  contact_email: string
  document_folder_id: number
  documents: Document[] | null
  endorsed?: boolean
  hmrc_resolution: AdvanceAssuranceHmrcResolution | null
  hmrc_resolution_note: string | null
  hmrc_review_at: string | null
  id: number
  in_progress_at: string | null
  pending_approval_note: string | null
  pending_client_approval_at: string | null
  ready_for_hmrc_at: string | null
  received_at: string
  request_type: AdvanceAssuranceRequestType
  requested_by: string
  status: AdvanceAssuranceRequestStatus
  assignee?: {
    email: string | null
    id: number | null
    legal_name: string | null
  }
  company: {
    company_name: string
    eis_knowledge_intensive: boolean
    id: number
    implementation_manager_name: string | null
  }
}

export interface AdvanceAssuranceRequestPostParams {
  request_type: AdvanceAssuranceRequestType
}

export interface AdvanceAssuranceRequestPutParams {
  assignee_id?: number | null
  cancellation_reason?: string | null
  completed_at?: string | null
  documents_attributes?: DocumentAttributes[]
  endorsed?: boolean | null
  hmrc_resolution?: AdvanceAssuranceHmrcResolution
  hmrc_resolution_note?: string | null
  hmrc_review_at?: string | null
  pending_approval_note?: string | null
  request_type?: AdvanceAssuranceRequestType
  status?: AdvanceAssuranceRequestStatus
}

export interface AdvanceAssuranceRequests {
  total_count: number
  values: AdvanceAssuranceRequest[]
  grouped_counts?: {
    active: number
    all: number
  }
}

export enum AdvanceAssuranceRequestStatus {
  IN_PROGRESS = 1,
  COMPLETED = 2,
  CANCELLED = 3,
  RECEIVED = 5,
  PENDING_CLIENT_APPROVAL = 6,
  READY_FOR_HMRC = 7,
  HMRC_REVIEW = 8,
}

export enum AdvanceAssuranceRequestType {
  EIS = 0,
  SEIS = 1,
  EIS_AND_SEIS = 2,
}

export enum AdvanceAssuranceRequestTypeKeys {
  EIS = 'EIS',
  SEIS = 'SEIS',
  EIS_AND_SEIS = 'EIS_AND_SEIS',
}

export interface AllotmentFilingParams {
  status?: ShareRegisterStatus
  share_class_id?: number[]
  included_allotment_ids?: number[]
  excluded_allotment_ids?: number[]
  company_id: number | null
  include_all_allotments?: boolean | null
  from_date?: string | null
  to_date?: string | null
  name_or_bkey?: string | null
}

export enum AllotmentFilingStatus {
  GENERATED = 0,
  FILED = 1,
  REJECTED = 2,
  APPROVED = 3,
  NOT_GENERATED = 10,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export interface AllStatistics {
  counts?: {
    total: number
  }
  votes?: {
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  quantity?: {
    stakeholder_category: Array<{
      by_share_class: NameValueSet
      id: number
      name: string
      value: number
      share: number
    }>
    country: IdValueSet
    share_class: NameValueSet
    available: number
    total: number
    total_incl_deferred: number
  }
}

export interface ApiActiveStakeholders {
  ids: string
  share_class_id: number
  plan_id?: number
  plan_name?: string
  currencies?: string
  count: string
  security_type: string
  share_class_name: string
}

export type AssignedStakeholder = LightStakeholder & {
  holding_company_locked?: boolean
  registered_entity_id?: number
  registered_entity_type?: RegisteredEntityType
}

export interface AssignImplementationManagerPutParams {
  implementation_manager_id: number
}

export interface Authorization {
  role: AccessRole
  level: AccessLevel
  config?: unknown
}

export interface AutomationRule {
  id: number
  company_id: number
  countries?: string[]
  fallback_conversion_price?: number
  fallback_conversion_price_currency?: string
  job_levels?: JobLevels
  name: string
  security_plan_id?: number
  status?: AutomationRuleStatus
  new_joiners_granted?: number
  security_plan_name?: string
}

export interface AutomationRulePayload {
  countries?: string[]
  fallback_conversion_price?: number
  fallback_conversion_price_currency?: string
  job_levels?: JobLevels
  name: string
  security_plan_id?: number
  status?: AutomationRuleStatus
}

export interface AutomationRules {
  total_count: number
  values: AutomationRule[]
}

export enum AutomationRuleStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  ARCHIVED = 2,
}

export interface BandAttributes {
  id?: number
  job_level?: string
  department?: string
  min_salary?: number
  max_salary?: number
  role?: string
  equity_percentage_of_salary?: number
  track?: JobTrack
  level?: number
  _destroy?: boolean
}

export interface BaseFlow {
  can_update_witness?: boolean
  company_id?: number
  company_name?: string
  created_at: string
  flowable?: Flowable
  id: number
  roles_present_in_documents?: SignatureStakeholderRole[]
  signatory_party?: FlowSignatoryParty
  state_info?: FlowStateInfo
  state_value: number
  status?: FlowStatus
  tasks?: Task[]
  timeline?: FlowTimelineEvent[]
  type: FlowType
}

export interface BaseShareClass {
  id: number
  approval_date: string
  description?: string
  effective_date: string
  is_inactive: boolean
  name: string
  nominal_value: string
  nominal_value_currency: Currency
  is_deferred: boolean
  preference_multiple?: string
  preference_participation: boolean
  votes: number
  config_share_certificates_initial_number: number | null
  has_transactions: boolean
  active_stakeholders: ApiActiveStakeholders[]
  sellable_amounts: SellableAmount[]
  has_signed_or_in_signing_share_certificates: boolean
  next_certificate_number: number
}

export interface BaseStatistics {
  company?: IndexCompany
  security_plan: SecurityPlanStatistics
  document_set: DocumentSetStatistics
  valuation: ValuationStatistics
  company_id: number
  date: string
  exclude_debts: boolean
  exclude_grants: boolean
  simulate_debt_conversion: boolean
  conversion_valuation: number
}

export interface BaseStatisticsData {
  all: AllStatistics
  option: OptionStatistics
  rsu: RsuStatistics
  warrant: WarrantStatistics
  share: ShareStatistics
  incentive_pool: IncentivePoolStatistics
  phantom_share: PhantomShareStatistics
  share_grant: ShareGrantStatistics
  stakeholder: StakeholderStatistics
  funding_rounds?: number
}

export type BenchmarkValues = Record<string, number>;

export interface BillingCustomer {
  payment_method?: PaymentMethod
  card?: BillingCustomerCard
  subscription?: BillingCustomerSubscription
  billing_orders?: BillingOrder[]
  id: number
  billing_email?: string
  company_name?: string
  company_name_same_as_company?: boolean
  company_id?: number
  tax_address_same_as_company_address?: boolean
  tax_address1?: string
  tax_address2?: string
  tax_city?: string
  tax_country?: string
  tax_postcode?: string
  tax_region?: string
  tax_registration_number?: string
  tax_percentage?: number
  stripe_id?: string
}

export interface BillingCustomerCard {
  exp_month: number
  exp_year: number
  last4: string
}

export interface BillingCustomerSubscription {
  comment?: string
  contract_length_in_months?: number
  discount?: number
  assisted_onboarding?: boolean
  onboarding_price?: number
  period_type?: number
  price?: number
  start_date?: string
  end_date?: string
  renewal_date?: string
  customized_start_date?: boolean
  price_currency?: Currency
  pricing_package?: SubscriptionPricingPackage
}

export interface BillingOrder {
  id: number
  billing_customer_id?: number
  end_date?: string
  period_type?: number
  start_date?: string
  discount?: number
  price?: number
  assisted_onboarding?: boolean
  trial_end_date?: string
  onboarding_price?: number
  contract_length_in_months?: number
  stakeholder_limit?: number
  comment?: string
  linked_accounts?: string
  currency?: Currency
  pricing_package?: SubscriptionPricingPackage
}

export type BoardResolution = Resolution & {
  resolution_category: BoardResolutionCategory
}

export enum BoardResolutionCategory {
  WRITTEN = 0,
  MINUTES = 1,
  OTHER = 2,
}

export interface BoardResolutions {
  values: BoardResolution[]
  total_count: number
}

export interface BulkSendShareCertificatesForSigningPostParams {
  company_id: number
  action_type: ShareCertificateBatchActionType
  name_or_bkey?: string
  included_ids?: number[]
  excluded_ids?: number[]
}

export interface BySigneeTypeAndSigningOrder {
  by_signee_type_and_signing_order: DocumentSetStat[]
}

export enum CaptableAccessLevel {
  PERSONAL = 1,
  ANONYMOUS = 2,
  WITHOUT_CONTACT_DETAILS = 3,
  FULL = 4,
}

export enum CashRunway {
  ZERO_TO_SIX_MONTHS = 0,
  SIX_MONTHS_TO_ONE_YEAR = 1,
  ONE_YEAR_TO_TWO_YEARS = 2,
  TWO_YEARS_TO_THREE_YEARS = 3,
  THREE_PLUS_YEARS = 4,
}

export enum CashSettlementPayoutCalculation {
  FULL = 0,
  APPRECIATION = 1,
}

export enum CashSettlementPayoutType {
  EXIT = 0,
}

export interface ClaimToken {
  id?: number
  hashed_token?: string
  created_at?: string
  updated_at?: string
  active?: boolean
}

export enum ClaimTokenValidity {
  DURATION_DAYS = 30,
}

export interface CommonFilingParams {
  date_of_changes?: string | null
  date_of_termination?: string | null
  previous_version_id?: number | null
}

export interface CommonShareTransaction {
  id: number
  company_id: number
  transactioned: string
  quantity: number
  price: number
  has_been_filed: boolean
  translated_type: string
  translated_type_simplified: string
  is_company_transaction: boolean
  is_registered?: boolean
  consideration_payment_date?: string
  cost?: number
  external_transaction_id?: number
  funding_round_id?: number
  is_filing_required?: boolean
  is_buyback?: boolean
  is_cancellation?: boolean
  is_eis?: boolean
  is_group_transfer?: boolean
  is_group_issuance_transaction?: boolean
  is_group_amendment_transaction?: boolean
  is_seis?: boolean
  is_share_class_conversion?: boolean
  is_transfer_or_grant_transfer?: boolean
  price_rate?: number
  priority_key?: number
  registered?: string
  security_grant_id?: number
  share_numbers?: string
  updated_at?: string
  funding_round_name?: string
  published?: string
  retired?: string
  seller_id?: number
  buyer_id?: number
  price_currency?: Currency
  cancellation_reason?: TransactionCancellationReason
  execution_type: TransactionExecutionType
  registration_class: RegistrationClass
  transaction_origin: TransactionOrigin
  transaction_type?: TransactionType
  seller?: LightStakeholder
  buyer?: LightStakeholder
  registration_state?: RegistrationState
  registration_state_category?: RegistrationStateCategory
  registration_status?: RegistrationStatus
}

export type CompanyAccess = MinimumCompanyAccess & {
  id: number | null
  is_default_1: boolean | null
  is_default_2: boolean | null
  is_default_3: boolean | null
}

export enum CompanyFeature {
  VALUATIONS_409A = 1,
  VALUATIONS_HMRC = 2,
  EXIT_MODELING = 3,
  SHARE_BASED_PAYMENTS = 4,
  HR_INTEGRATIONS = 5,
  VALUATIONS_GROWTH_SHARES = 6,
  LEGACY_SHARE_BASED_PAYMENTS = 7,
  ROUND_CLOSING = 8,
  COMPENSATION_MANAGEMENT = 9,
  S_EIS = 10,
  EQUITY_PLAN_MANAGEMENT = 11,
  GOVERNANCE = 12,
  EMI_SHARE_PLAN = 13,
  ADVANCE_ASSURANCE = 14,
}

export interface CompanyFeaturesPutParams {
  enabled_features: CompanyFeature[]
}

export interface CompanyFeaturesResponse {
  id: number
  company_name: string
  enabled_features: CompanyFeature[]
}

export type CompanyPutParams = ShowCompany & {
  share_classes_attributes?: Array<{
    id?: number
    config_share_certificates_initial_number?: number
  }>
  ch_presenter_auth_code?: string | null
  complete_cosec_activation?: boolean | null
}

export interface CompanyRelation {
  type: string
  to?: string | null
  from: string
  status: RelationStatus
  active: boolean
}

export interface CompanySetupItem {
  completed_at: string | null
  due_at: string | null
  last_nudged_at: string | null
  public_note: string | null
  due_date_change_reason: string | null
  assignee?: {
    id: number
    legal_name: string
  }
  error_details?: string[]
  itemable_type: CompanySetupItemItemableType | null
  itemable_id: number | null
  status: CompanySetupItemStatus
  type: CompanySetupItemType
  assignee_id: number
  can_be_completed: boolean
  completed: boolean
  id: number
  translated_title: string
}

export enum CompanySetupItemItemableType {
  DOCUMENT_FOLDER = 'Document::DocumentFolder',
}

export interface CompanySetupItemsBulkUpdateParams {
  company_setup_items?: Array<{
    id?: number
    status?: CompanySetupItemStatus
    assignee_id?: number
    public_note?: string | null
    due_at?: string
    due_date_change_reason?: string
  }>
}

export interface CompanySetupItemsNudgeCustomerParams {
  message?: string
}

export enum CompanySetupItemStatus {
  INCOMPLETE = 0,
  COMPLETE = 1,
}

export interface CompanySetupItemsUpdateParams {
  status?: CompanySetupItemStatus
  assignee_id?: number
  public_note?: string | null
  due_at?: string
  due_date_change_reason?: string
}

export enum CompanySetupItemType {
  ADD_FUNDING_ROUNDS = 'Actor::Company::CompanySetupItem::AddFundingRounds',
  ADD_SHARE_CLASSES = 'Actor::Company::CompanySetupItem::AddShareClasses',
  CONFIGURE_STAKEHOLDER_SETTINGS = 'Actor::Company::CompanySetupItem::ConfigureStakeholderSettings',
  CONFIRM_COMPANY_DATA = 'Actor::Company::CompanySetupItem::ConfirmCompanyData',
  GO_LIVE = 'Actor::Company::CompanySetupItem::GoLive',
  INVITE_ADMINISTRATORS = 'Actor::Company::CompanySetupItem::InviteAdministrators',
  INVITE_LEGAL_CONTACT = 'Actor::Company::CompanySetupItem::InviteLegalContact',
  PREVIEW_STAKEHOLDER_DASHBOARD = 'Actor::Company::CompanySetupItem::PreviewStakeholderDashboard',
  REQUEST_GO_LIVE = 'Actor::Company::CompanySetupItem::RequestGoLive',
  REVIEW_ADMINISTRATOR_ACCESS = 'Actor::Company::CompanySetupItem::ReviewAdministratorAccess',
  REVIEW_COMPANY_DATA = 'Actor::Company::CompanySetupItem::ReviewCompanyData',
  REVIEW_SETTINGS_AND_ADDONS = 'Actor::Company::CompanySetupItem::ReviewSettingsAndAddons',
  SET_UP_COMPANY_REGISTERS = 'Actor::Company::CompanySetupItem::SetUpCompanyRegisters',
  TEST_GO_LIVE = 'Actor::Company::CompanySetupItem::TestGoLive',
  TEST_INVITATION_EMAIL = 'Actor::Company::CompanySetupItem::TestInvitationEmail',
  UPLOAD_NOTEHOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadNoteholderData',
  UPLOAD_ONBOARDING_DATA = 'Actor::Company::CompanySetupItem::UploadOnboardingData',
  UPLOAD_OPTIONHOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadOptionholderData',
  UPLOAD_PHANTOM_SHARE_HOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadPhantomShareHolderData',
  UPLOAD_RSU_HOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadRsuHolderData',
  UPLOAD_SHARE_GRANT_HOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadShareGrantHolderData',
  UPLOAD_SHAREHOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadShareholderData',
  UPLOAD_WARRANTHOLDER_DATA = 'Actor::Company::CompanySetupItem::UploadWarrantholderData',
}

export enum CompanyStatement {
  NO_REGISTRABLE_PERSON_OR_RLE = 'NO_REGISTRABLE_PERSON_OR_RLE',
  TAKING_REASONABLE_STEPS = 'TAKING_REASONABLE_STEPS',
}

export interface CompensationBand {
  id: number
  compensation_configuration_id: number
  job_level?: string
  department?: string
  min_salary?: number
  max_salary?: number
  mid_salary?: number
  mid_equity?: number
  role?: string
  equity_percentage_of_salary?: number
  equity_benchmark_values?: BenchmarkValues
  salary_benchmark_values?: BenchmarkValues
  equity_compa_ratio?: number
  salary_compa_ratio?: number
  equity_range?: CompensationRange
  salary_range?: CompensationRange
}

export interface CompensationConfiguration {
  departments?: Record<string, string>
  job_levels?: Record<string, CompensationJobLevel[]>
  id: number
  company_id: number
  bands?: CompensationBand[]
  is_draft?: boolean
  max_valuation_in_millions?: number
  step?: string
  target_percentile?: number
  country?: string
  benchmark_country?: string
  currency?: string
  updated_at?: string
  versioned_at?: string
}

export interface CompensationConfigurationPayload {
  departments?: Record<string, string>
  job_levels?: Record<string, CompensationJobLevel[]>
  id?: number
  is_draft?: boolean
  company_id?: number
  max_valuation_in_millions?: number
  country?: string
  benchmark_country?: string
  target_percentile?: number
  currency?: string
  bands_attributes?: BandAttributes[]
  step?: string
}

export interface CompensationDepartments {
  matches?: Record<string, string>
  hris: string[]
  benchmarks: string[]
}

export interface CompensationJobLevel {
  role: string
  track: JobTrack
  level: number
  selected: boolean
}

export type CompensationRange = number[]

export enum CompensationScore {
  LOW = 0,
  MID = 1,
  HIGH = 2,
}

export interface CompensationSkeleton {
  countries: string[]
  percentiles: number[]
  job_levels: CompensationSkeletonJobLevel[]
  valuation_stages: ValuationStage[]
  departments: CompensationDepartments
}

export interface CompensationSkeletonJobLevel {
  level: number
  track: JobTrack
}

export interface ComplianceAggregateStatusItem {
  count: number
  type: ComplianceItemType
  last_archived_at?: string
  last_completed_at?: string
}

export enum ComplianceItemStatus {
  AT_RISK = 0,
  NOT_COMPLIANT = 1,
  FULLY_COMPLIANT = 2,
}

export enum ComplianceItemType {
  GENERATE_CSOP_ANNUAL_RETURN = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::GenerateCsopAnnualReturnItem',
  GENERATE_EMI_ANNUAL_RETURN = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::GenerateEmiAnnualReturnItem',
  GENERATE_OTHER_ERS_ANNUAL_RETURN = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::GenerateOtherErsAnnualReturnItem',
  MARK_AS_FILED = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::MarkAsFiledItem',
  NOTIFY_HMRC = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::NotifyHmrcItem',
  REGISTER_PLAN_TO_HMRC = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::RegisterPlanToHmrcItem',
  REQUEST_FIRST_VALUATION = 'Actor::Company::StatusItem::Compliance::CountryLogic::Gb::RequestFirstValuationItem',
  CUSTOM_ITEM = 'Actor::Company::StatusItem::Compliance::CustomItem',
  MISSING_VALUATION = 'Actor::Company::StatusItem::Compliance::MissingValuationItem',
  REQUEST_NEW_VALUATION = 'Actor::Company::StatusItem::Compliance::RequestNewValuationItem',
}

export interface ComplianceMetadata {
  value: Record<string, unknown>
  type: ComplianceItemType
}

export interface ComplianceStatusItem {
  id: number
  itemable_id?: number
  itemable_type?: string
  type: ComplianceItemType
  deadline?: string | null
  archived_at: string | null
  completed_at?: string | null
  status?: StatusItemStatus
  filing_year_period?: string[] | null
  metadata?:
    | ComplianceStatusItemNotifyHmrcItemMetadata
    | ComplianceStatusItemCustomItemMetadata
    | ComplianceStatusItemMarkAsFiledItemMetadata
    | ComplianceStatusItemRequestNewValuationMetadata
    | ComplianceStatusItemGenerateAnnualReturnItemMetadata
    | ComplianceStatusItemRegisterPlanToHmrcItemMetadata
}

export interface ComplianceStatusItemCustomItemMetadata {
  title?: string
  created_at: string
  creator_name: string
  updater_name?: string
}

export interface ComplianceStatusItemGenerateAnnualReturnItemMetadata {
  security_plans: Record<string, unknown>
}

export interface ComplianceStatusItemMarkAsFiledItemMetadata {
  created_at: string
  security_plan_name?: string
}

export interface ComplianceStatusItemNotifyHmrcItemMetadata {
  granted: string
}

export interface ComplianceStatusItemRegisterPlanToHmrcItemMetadata {
  created_at: string
  name: string
}

export interface ComplianceStatusItemRequestNewValuationMetadata {
  share_class_name?: string
}

export interface ComplianceStatusItems {
  aggregates: ComplianceAggregateStatusItem[]
  metadata?: ComplianceMetadata[]
  values: ComplianceStatusItem[]
  compliance_status?: ComplianceItemStatus
  limits?: {
    optionholders_by_limit_status: {
      '0'?: number
      '1'?: number
      '2'?: number
      '3'?: number
    }
    outstanding_emi_values: string
  }
}

export enum CompoundingPeriod {
  DAY = 0,
  MONTH = 1,
  QUARTER = 2,
  BIANNUAL = 3,
  YEAR = 4,
}

export interface ConfigureSignatoriesParams {
  spec: {
    '0'?: number | null
    '1'?: number | null
    '2'?: number | null
    '3'?: number | null
    '4'?: number | null
  }
}

export interface ConfirmMembershipStartDatesPostParams {
  company_id: number
  action_type: MemberBatchActionType
  member_data: MemberStartDateConfirmData[]
}

export interface ConversionOrderExecution {
  id: number
  type: string
  cost?: string
  currency?: Currency
  offline_payment_comment?: string
  fee?: number
  filing_fee?: number
  receivable?: boolean
  quantity?: string
  status?: number
  has_failed_flow?: boolean
  transactions: SecurityTransaction[]
  documents: Document[]
  timeline_status?: ConversionTimelineStatus
  offline_payment_status?: OfflinePaymentStatus
  order?: Order
  transaction_set?: {
    id: number
  }
  grants?: Convertible[]
  offline_payment_date?: string
  created_at?: string
  transactioned?: string
  flows?: Flow[]
}

export enum ConversionTimelineStatus {
  PENDING_GRANTHOLDER_WITNESS_SIGNATURE = 0,
  PENDING_ISSUER_SIGNATURE = 1,
  PENDING_ISSUER_WITNESS_SIGNATURE = 2,
  PENDING_PAYMENT = 3,
  PENDING_PUBLISHING = 4,
  COMPLETED = 5,
  CANCELLED = 6,
  FAILED = 7,
  NOT_SUBMITTED = 8,
}

export enum ConversionWindowStatus {
  SCHEDULED_EXERCISE_WINDOW = 0,
  PENDING_EXERCISE = 1,
}

export interface Convertible {
  conversion_note: string
  conversion_price?: string
  exercisable_in_secondary?: boolean
  id: number
  in_open_conversion_window_without_exercise?: boolean
  is_terminating?: boolean
  liquidity_event_id?: number
  type: string
  conversion_price_currency?: Currency
  conversion_document_set?: DocumentSet | null
  conversion_window_status?: ConversionWindowStatus | null
  granted?: string
  conversion_window_end?: string
  convertible?: string
  termination_retain_vested_quantity: string
  share_class_nominal_value_currency?: Currency
  share_class_name?: string
  share_class_id?: number
  company?: {
    id: number
    company_name?: string
    terminology_settings?: {
      phantom_share_naming?: string
      exercise_price_naming?: string
    }
  }
  security_plan?: {
    security_plan_type?: OptionPlanType
    name?: string
    type?: string
  }
}

export interface CreateOnlineEmiSharePlanPostParams {
  plan_name: string
  share_class_id: number
  leaver_type: EmiSharePlanLeaverType
  pool_authorization_authorized?: number
  default_vesting?: boolean
  includes_non_uk?: boolean
  includes_non_employee?: boolean
}

export interface CreateResolutionsPostParams {
  company_id: number
  action_type: ResolutionBatchActionType
  metadata: {
    resolution_type?: string
    resolutions_data?: ResolutionParams[]
  }
}

export enum Currency {
  AED = 'AED',
  AFN = 'AFN',
  ALL = 'ALL',
  AMD = 'AMD',
  ANG = 'ANG',
  AOA = 'AOA',
  ARS = 'ARS',
  AUD = 'AUD',
  AWG = 'AWG',
  AZN = 'AZN',
  BAM = 'BAM',
  BBD = 'BBD',
  BDT = 'BDT',
  BGN = 'BGN',
  BHD = 'BHD',
  BIF = 'BIF',
  BMD = 'BMD',
  BND = 'BND',
  BOB = 'BOB',
  BRL = 'BRL',
  BSD = 'BSD',
  BTN = 'BTN',
  BWP = 'BWP',
  BYN = 'BYN',
  BYR = 'BYR',
  BZD = 'BZD',
  CAD = 'CAD',
  CDF = 'CDF',
  CHF = 'CHF',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  CUP = 'CUP',
  CVE = 'CVE',
  CZK = 'CZK',
  DJF = 'DJF',
  DKK = 'DKK',
  DOP = 'DOP',
  DZD = 'DZD',
  EGP = 'EGP',
  ERN = 'ERN',
  ETB = 'ETB',
  EUR = 'EUR',
  FJD = 'FJD',
  FKP = 'FKP',
  GBP = 'GBP',
  GEL = 'GEL',
  GHS = 'GHS',
  GIP = 'GIP',
  GMD = 'GMD',
  GNF = 'GNF',
  GTQ = 'GTQ',
  GYD = 'GYD',
  HKD = 'HKD',
  HNL = 'HNL',
  HRK = 'HRK',
  HTG = 'HTG',
  HUF = 'HUF',
  IDR = 'IDR',
  ILS = 'ILS',
  INR = 'INR',
  IQD = 'IQD',
  IRR = 'IRR',
  ISK = 'ISK',
  JMD = 'JMD',
  JOD = 'JOD',
  JPY = 'JPY',
  KES = 'KES',
  KGS = 'KGS',
  KHR = 'KHR',
  KMF = 'KMF',
  KPW = 'KPW',
  KRW = 'KRW',
  KWD = 'KWD',
  KYD = 'KYD',
  KZT = 'KZT',
  LAK = 'LAK',
  LBP = 'LBP',
  LKR = 'LKR',
  LRD = 'LRD',
  LSL = 'LSL',
  LYD = 'LYD',
  MAD = 'MAD',
  MDL = 'MDL',
  MGA = 'MGA',
  MKD = 'MKD',
  MMK = 'MMK',
  MNT = 'MNT',
  MOP = 'MOP',
  MRU = 'MRU',
  MUR = 'MUR',
  MVR = 'MVR',
  MWK = 'MWK',
  MXN = 'MXN',
  MYR = 'MYR',
  MZN = 'MZN',
  NAD = 'NAD',
  NGN = 'NGN',
  NIO = 'NIO',
  NOK = 'NOK',
  NPR = 'NPR',
  NZD = 'NZD',
  OMR = 'OMR',
  PAB = 'PAB',
  PEN = 'PEN',
  PGK = 'PGK',
  PHP = 'PHP',
  PKR = 'PKR',
  PLN = 'PLN',
  PYG = 'PYG',
  QAR = 'QAR',
  RON = 'RON',
  RSD = 'RSD',
  RUB = 'RUB',
  RWF = 'RWF',
  SAR = 'SAR',
  SBD = 'SBD',
  SCR = 'SCR',
  SDG = 'SDG',
  SEK = 'SEK',
  SGD = 'SGD',
  SHP = 'SHP',
  SLL = 'SLL',
  SOS = 'SOS',
  SRD = 'SRD',
  SSP = 'SSP',
  STD = 'STD',
  SYP = 'SYP',
  SZL = 'SZL',
  THB = 'THB',
  TJS = 'TJS',
  TMT = 'TMT',
  TND = 'TND',
  TOP = 'TOP',
  TRY = 'TRY',
  TTD = 'TTD',
  TWD = 'TWD',
  TZS = 'TZS',
  UAH = 'UAH',
  UGX = 'UGX',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VES = 'VES',
  VND = 'VND',
  VUV = 'VUV',
  WST = 'WST',
  XAF = 'XAF',
  XCD = 'XCD',
  XOF = 'XOF',
  XPF = 'XPF',
  YER = 'YER',
  ZAR = 'ZAR',
  ZMW = 'ZMW',
}

export interface CustomValuation {
  updated_at: string
  share_price: number
  currency: Currency
}

export enum DayCountType {
  ACTUAL_365_F = 0,
  ACTUAL_360 = 1,
}

export interface Debt {
  accrual_start_date?: string
  consideration_payment_date?: string
  created_at?: string
  issued: string
  matures?: string
  published?: string
  revoked?: string
  updated_at?: string
  offline_payment_at?: string
  any_conversions?: boolean
  can_be_revoked_and_published?: boolean
  cancelled?: number
  converted?: number
  debt_transactions_draft_count?: number
  debt_transactions_publish_count?: number
  debt_transactions_revoked_count?: number
  filtered_debt_transactions_draft_count?: number
  id: number
  interest?: number
  is_conversion_price_fixed?: boolean
  outstanding_total?: string
  outstanding?: string
  principal: number
  repaid?: number
  share_class_id: number
  use_manual_share_inputs?: boolean
  conversion_price?: number
  conversion_price_discount?: number
  conversion_price_rate?: string
  interest_rate?: number
  is_one_time_fixed_interest?: boolean
  is_secured?: boolean
  qualifying_financing_rate?: number
  round_valuation?: number
  valuation_cap_rate?: number
  share_class_name: string
  issuance_transaction_id?: number
  is_published: boolean
  funding_round_name?: string
  creator?: string
  updater?: string
  translated_acceptance_status?: string
  legal_name?: string
  status: DebtStatus[]
  price_currency: Currency
  conversion_price_currency?: Currency
  round_valuation_currency?: Currency
  share_class_nominal_value_currency?: Currency
  funding_round_id?: number | null
  is_compound_interest?: boolean | null
  priority_key?: number | null
  qualifying_financing?: number | null
  valuation_cap?: number | null
  longstop_valuation?: number | null
  note?: string | null
  offline_payment_note?: string | null
  longstop_valuation_interval?: number | null
  qualifying_financing_currency?: Currency
  valuation_cap_currency?: Currency
  longstop_valuation_currency?: Currency
  debt_type: DebtType
  longstop_valuation_interval_unit?: LongstopValuationIntervalUnit
  hmrc_scheme_type?: HmrcSchemeType
  day_count_type?: DayCountType
  interest_compounding_period?: CompoundingPeriod
  accrual_method?: AccrualMethod
  debtholder?: LightStakeholder
  company: {
    id: number
    company_name: string
    email: string
  }
  debt_transactions: DebtDebtTransaction[]
  interest_accruals?: Array<{
    created_at?: string
    from?: string
    to?: string
    transactioned?: string
    display_url?: string
    quantity?: string
  }>
  documents?: Document[]
  debt_ids?: number[]
}

export enum DebtCancellationReason {
  CONVERSION = 0,
  BUYBACK = 2,
  EXPIRATION = 3,
  SHARE_CAPITAL_VARIATION = 4,
  DEATH = 5,
  DISABILITY = 6,
  LEAVE_INVOLUNTARILY = 7,
  LEAVE_VOLUNTARILY = 8,
  SHARE_CLASS_CONVERSION = 10,
  RELEASE = 11,
  SURRENDER = 12,
  TERMINATION = 13,
  TRANSFER = 14,
  OTHER = 99,
  REPAYMENT = 100,
}

export interface DebtDebtTransaction {
  accrual_start_date?: string
  transactioned: string
  id: number
  quantity: string
  revoked: boolean
  type: string
  debt_transaction_type: number
}

export enum DebtFlowIssuanceOrderExecutionState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PROCESSING_DOCUMENTS = 200,
  PUBLISHING_SIGNING_PACKAGE = 201,
  STAKEHOLDER_SIGNING = 202,
  ISSUER_SIGNING = 203,
  ISSUER_APPROVING = 204,
}

export interface DebtIssuanceOrderExecution {
  id: number
  cost: string
  fee: number
  filing_fee: number
  quantity: string
  status: number
  type: string
  currency: Currency
  receivable: boolean | null
  created_at: string
  signing_package_expiry_date: string | null
  transactioned: string
  order?: Order
  flows?: Flow[]
  documents?: Document[]
  debt: {
    id: number
    is_conversion_price_fixed: boolean
    principal: number
    price_currency: Currency
    conversion_price_discount: number | null
    valuation_cap: number | null
    valuation_cap_rate: number | null
    valuation_cap_currency: Currency
    debt_type: DebtType
  }
}

export enum DebtQuantityStatus {
  CUSTOM = 0,
  OUTSTANDING = 1,
}

export interface DebtStatistics {
  counts: {
    asa: number
    other: number
    safe: number
    standard: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  debts_currency_map: {
    id: string
    name: string
    value: number
  }
  quantity: {
    currency: {
      id: string
      name: string
      value: number
    }
  }
  outstanding: NameValueSet
  interest: NameValueSet
  principal: NameValueSet
}

export enum DebtStatus {
  DRAFT = 0,
  ACTIVE = 1,
  REVOKED = 2,
  TERMINATED = 3,
  CONVERTED = 4,
  CANCELLED = 5,
  REPAID = 6,
}

export enum DebtTransactionType {
  ISSUANCE = 0,
  CONVERSION = 1,
  CANCELLATION = 2,
  REPAYMENT = 4,
  ADJUSTMENT = 5,
}

export enum DebtType {
  STANDARD = 0,
  SAFE = 1,
  ASA = 2,
  OTHER = 99,
}

export interface DecimalPrecision {
  price_precision: number
  hurdle_price_precision: number
  option_conversion_price_precision: number
  warrant_conversion_price_precision: number
  rsu_conversion_price_precision: number
  nominal_value_precision: number
  valuation_price_precision: number
}

export interface DetailDiff {
  name?: DetailFieldDiff
  date_of_birth?: DetailFieldDiff
  building_name?: DetailFieldDiff
  street?: DetailFieldDiff
  city?: DetailFieldDiff
  postcode?: DetailFieldDiff
  country?: DetailFieldDiff
  region?: DetailFieldDiff
  registration_number?: DetailFieldDiff
}

export interface DetailFieldDiff {
  stakeholder: string
  registers: string
}

export interface DirectorDetailsAttributes {
  individual_first_name?: string
  individual_last_name?: string
  individual_title?: string
  building_name?: string
  street?: string
  post_town?: string
  county?: string
  residential_building_name?: string
  residential_street?: string
  residential_post_town?: string
  residential_county?: string
  residential_postcode?: string
  residential_country?: string
  nationality?: string
  date_of_birth?: string
  business_occupation?: string
  section243_exemption?: boolean
  postcode?: string
  country?: string
  corporate_governing_law?: string
  corporate_legal_form?: string
  corporate_name?: string
  corporate_registered?: string
  corporate_registration_number?: string
  date_of_board_approving_appointment?: string
  stakeholder_id?: number
  individual_former_names?: Array<{
    first_name?: string
    last_name?: string
  }>
}

export type DirectorFilingParams = CommonFilingParams & {
  filing_type?: DirectorFilingType
  identity_verification_number?: string
}

export enum DirectorFilingType {
  AP01 = 'Reporting::Reports::Gb::Ap01',
  AP02 = 'Reporting::Reports::Gb::Ap02',
  CH01 = 'Reporting::Reports::Gb::Ch01',
  CH02 = 'Reporting::Reports::Gb::Ch02',
  TM01 = 'Reporting::Reports::Gb::Tm01',
}

export interface DirectorPostParams {
  details_attributes?: DirectorDetailsAttributes
  filing_type?: DirectorFilingType
  status?: number
  appointed_at?: string
  terminated_at?: string
  consent_to_act?: boolean
}

export interface DirectorPreviewTerminateParams {
  filing_type: DirectorFilingType
  id: number
  date_of_changes: string
  date_of_termination: string
}

export interface DirectorPutParams {
  details_attributes?: DirectorDetailsAttributes
  filing_type?: DirectorFilingType
  id?: number
  changed_at?: string
  terminated_at?: string
}

export enum DisqualifiableType {
  STAKEHOLDER = 'Actor::Stakeholder::Stakeholder',
  SECURITY_GRANT = 'Security::Grant::SecurityGrant',
  SECURITY_PLAN = 'Security::Plan::SecurityPlan',
  SHARE_CLASS = 'Security::ShareClass::ShareClass',
  VALUATION = 'Security::Valuation::Valuation',
}

export interface DisqualifyingEvent {
  created_at: string
  occurred: string
  cancelled?: string
  disqualifying_event_type: DisqualifyingEventType
  documents?: Document[]
  id: number
  company_id: number
  note?: string
  disqualifiable_id?: number
  disqualifiable_type?: string
  emi_grants_draft_count: number
  emi_grants_publish_count: number
}

export interface DisqualifyingEventPostParams {
  company_id: number
  disqualifiable_id?: number
  disqualifiable_type?: DisqualifiableType
  disqualifying_event_type: DisqualifyingEventType
  documents_attributes?: DocumentAttributes[]
  note?: string
  occurred: string
}

export interface DisqualifyingEventPutParams {
  cancelled: string
}

export enum DisqualifyingEventType {
  LOSS_OF_INDEPENDENCE = 0,
  STOPPED_TRADING_ACTIVITIES = 1,
  OPTIONHOLDER_STOPPED_WORKING = 2,
  OPTION_TERM_CHANGES = 3,
  CHANGE_IN_SHARE_CAPITAL = 4,
  SHARE_CONVERSION = 5,
  INDIVIDUAL_EMI_AND_CSOP_LIMIT = 6,
  FAILED_QUALIFYING_TRADE = 7,
}

export interface Document {
  category: number
  created_at: string
  creator_name: string | null
  documentable_id: number
  documentable_type: string
  documentable_type_for_category?: string
  extension: string
  file_file_name: string | null
  file_file_size: number | null
  file_url: string | null
  id: number
  in_signing: boolean
  is_signable: boolean
  placeholders_present: string[] | null
  processing_error: string | null
  processing_status: number | null
  required_placeholders: string[] | null
  title: string
  title_with_extension: string
  type: string
  updated_at: string
  updater_name: string | null
}

export interface DocumentAttributes {
  create_from_id?: number
  id?: number
  title?: string
  category?: string
  _destroy?: boolean
  file?: Blob | File
}

export enum DocumentCategory {
  ISSUANCE_AGREEMENT = 0,
  CONVERSION_INSTRUCTIONS = 1,
  BOARD_RESOLUTION = 2,
  SHAREHOLDER_RESOLUTION = 3,
  PLAN = 4,
  J_GB_NIC_AGREEMENT_OR_ELECTION = 5,
  POWER_OF_ATTORNEY = 6,
  CERTIFICATE_OF_COMPLETION = 7,
  OTHER = 9,
  EMI_SHARE_PLAN_GOOD_LEAVER_BAD_LEAVER = 10,
  EMI_SHARE_PLAN_YOU_LEAVE_YOU_LOSE = 11,
  CANCELLATION_AGREEMENT = 101,
  SURRENDER_AGREEMENT = 102,
  SHAREHOLDER_AGREEMENT = 105,
  ARTICLES_OF_ASSOCIATION = 106,
  PURCHASE_AGREEMENT = 107,
  SHARE_PLACEMENT_AGREEMENT = 108,
  CONVERSION_AGREEMENT = 201,
  J_GB_SECTION431_SUBSECTION1_ELECTION = 202,
  J_GB_SECTION431_SUBSECTION2_ELECTION = 203,
  SIDE_LETTER = 301,
  ORDER_POA_BUYER = 400,
  ORDER_POA_SELLER = 401,
  ONLINE_BUYBACK_AGREEMENT = 402,
  TRANSACTION_SET_PURCHASE_AGREEMENT = 403,
  TRANSACTION_SET_DEED_OF_ADHERENCE = 404,
  DEBT_INVESTOR_AGREEMENT = 600,
  REPAYMENT_AGREEMENT = 601,
  GOVERNANCE_ASSOCIATED_DOCUMENT = 700,
  GOVERNANCE_BOARD_RESOLUTION = 701,
  GOVERNANCE_SHAREHOLDER_RESOLUTION = 702,
  VALUATION_REPORT = 800,
  HMRC_ACCEPTANCE_LETTER = 801,
  VAL231 = 802,
  APPLICATION_LETTER = 900,
  APPLICATION_FORM = 901,
  HMRC_RESOLUTION = 902,
  PROOF_OF_PAYMENT = 1000,
  INVESTMENT_AGREEMENT = 1001,
  SHARE_CERTIFICATE = 1002,
  WATERMARKED_SHARE_CERTIFICATE = 1003,
  SHARE_GRANT_AGREEMENT = 1004,
  EIS3 = 1005,
  SEIS3 = 1006,
  FILING = 1100,
  FILING_REJECTION = 1101,
  FILING_APPROVAL = 1102,
  NEWS = 1200,
  COMPANY_GENERAL = 1300,
  COMPANY_GENERAL_ASSEMBLIES = 1301,
  COMPANY_PRESS = 1302,
  COMPANY_TAX = 1303,
  COMPANY_INVESTOR = 1304,
  COMPANY_FINANCIAL = 1305,
  COMPANY_COMPANY = 1306,
  COMPANY_LEGAL = 1307,
  COMPANY_ARTICLE = 1308,
  COMPANY_ARTICLES_OF_ASSOCIATION = 1309,
  J_GB_DEED_OF_ADHERENCE = 44101,
  J_GB_STOCK_TRANSFER_FORM = 44102,
}

export interface DocumentFolderIndex {
  id: number
  name: string
  created_at: string
  updated_at: string
  creator_id: string
  updater_id: string
  creator_name: string
  updater_name: string
  total_documents_count: number
  subfolders_count: number
  read_only: boolean
  archivable: boolean
  inside_read_only_folder: boolean
  status: DocumentFolderStatus
  folder_type: DocumentFolderType
  subfolders?: DocumentFolderShow[]
}

export interface DocumentFolderPayload {
  id?: number
  company_id?: number
  folder_type?: number
  name?: string
  status?: number
  folderable_type?: string
  folderable_id?: number
  blob_ids?: number[]
  documents_attributes?: Array<{
    id?: number
    _destroy?: boolean
  }>
}

export type DocumentFolderShow = DocumentFolderIndex & {
  parent_folder?: {
    id?: number
    name?: string
    folder_type?: DocumentFolderType
  }
}

export enum DocumentFolderStatus {
  ACTIVE = 0,
  ARCHIVED = 1,
}

export enum DocumentFolderType {
  ONBOARDING = 0,
  OTHER = 1,
}

export type DocumentsAttributes = Array<{
  create_from_id: number
  id: number
  title: string
  category: string
  _destroy: boolean
  file: Blob | File
}>

export interface DocumentSet {
  id: number
  document_setable_id: number
  document_setable_type: string
  name: string
  type: string
  signing_order: number
  created_at: string
  is_corporate: boolean
  documents?: Document[] | null
}

export interface DocumentSetCounts {
  option: {
    issuance: BySigneeTypeAndSigningOrder
    conversion: BySigneeTypeAndSigningOrder
  }
  warrant: {
    issuance: BySigneeTypeAndSigningOrder
    conversion: BySigneeTypeAndSigningOrder
  }
  share_grant: {
    issuance: BySigneeTypeAndSigningOrder
  }
  phantom_share: {
    issuance: BySigneeTypeAndSigningOrder
  }
  rsu: {
    issuance: BySigneeTypeAndSigningOrder
  }
}

export interface DocumentSetStat {
  signee_type: DocumentSigneeType
  witness_type: DocumentSigneeType
  signing_order: DocumentSigningOrder
  count: number
}

export interface DocumentSetStatistics {
  counts: DocumentSetCounts
}

export enum DocumentSigneeType {
  ISSUER_ONLY = 'issuer_only',
  STAKEHOLDER_ONLY = 'stakeholder_only',
  ISSUER_AND_STAKEHOLDER = 'issuer_and_stakeholder',
  NO_SIGNEE = 'no_signee',
}

export enum DocumentSigningOrder {
  NO_SIGNING = 'no_signing',
  STAKEHOLDER_FIRST = 'stakeholder_first',
  ISSUER_FIRST = 'issuer_first',
}

export interface DraftMode {
  id: number
  company_id: number
  user_id: number
  enable_drafts: boolean
}

export type DraftStatisticsData = BaseStatisticsData & {
  debt: {
    counts: {
      total: number
    }
  }
}

export interface Email {
  created_at: string
  updated_at: string
  source?: EmailSource
  id: number
  user_id: number
  email: string
  verified: boolean
  primary: boolean
  attempts: number
  locked_until?: string
}

export enum EmailSource {
  INTERNAL = 0,
  SIGNUP_INTERNAL = 1,
  SIGNUP_EXTERNAL = 2,
  OFFBOARDING = 3,
}

export interface EmiCsopLimitsDetails {
  limit_status: LimitStatus
  id: number
  legal_name: string
  csop_value: number
  emi_csop_value: number
  has_emi_or_csop_grant: boolean
  has_csop_grant: boolean
}

export interface EmiCsopLimitsSummary {
  id: number
  company_name: string
  outstanding_emi_values: string
  optionholders_by_limit_status: {
    '0'?: number
    '1'?: number
    '2'?: number
    '3'?: number
  }
}

export enum EmiSharePlanLeaverType {
  GOOD_LEAVER_BAD_LEAVER = 0,
  YOU_LEAVE_YOU_LOSE = 1,
}

export enum EmployeeBatchActionType {
  ONBOARD = 0,
  UPDATE_JOB_LEVEL = 1,
}

export interface EmployeeEquity {
  share_classes: string[] | null
  security_types: string[] | null
  votes: number | null
  ownership: number | null
  quantity: number | null
}

export enum EmployeeLifecycleStatus {
  ONBOARDED = 0,
  PENDING_OFFBOARDING = 1,
  OFFBOARDING_SCHEDULED = 2,
  OFFBOARDING_IN_PROGRESS = 3,
  OFFBOARDED = 4,
  PENDING_ONBOARDING = 5,
  ONBOARDING_IN_PROGRESS = 6,
  ONBOARDING_IN_DRAFT = 7,
}

export interface EmployeeStatistics {
  granted: string
  vested: string
  unvested: string
  fully_vested_at: string
}

export enum ExecutionType {
  OFFLINE = 0,
  ONLINE = 1,
}

export enum ExercisePriceNames {
  EXERCISE_PRICE = 'exercise_price',
  STRIKE_PRICE = 'strike_price',
}

export interface ExpenseReportingRequest {
  cancellation_reason: string | null
  cancelled_at: string | null
  completed_at: string | null
  contact_email: string
  id: number
  in_progress_at: string | null
  pending_client_approval_at: string | null
  public_note: string | null
  received_at: string
  report_end_at: string | null
  report_start_at: string | null
  requested_by: string
  staff_note?: string | null
  status: ExpenseReportingRequestStatus
  company: {
    account_status: AccountStatus
    company_name: string
    email: string
    feature_enabled: boolean
    id: number
  }
  expense_report: {
    filename: string | null
    url: string | null
  }
}

export interface ExpenseReportingRequestPutParams {
  status?: ExpenseReportingRequestStatus
  expense_report?: Blob | File
  cancellation_reason?: string
  public_note?: string | null
  staff_note?: string | null
  report_start_at?: string
  report_end_at?: string
}

export enum ExpenseReportingRequestStatus {
  IN_PROGRESS = 1,
  COMPLETED = 2,
  CANCELLED = 3,
  RECEIVED = 5,
  PENDING_CLIENT_APPROVAL = 6,
}

export enum ExpiresAdjustmentType {
  NONE = 0,
  ONLINE_EXECUTION = 1,
}

export enum ExpiresUnit {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
  YEAR = 3,
}

export interface ExpiringValuation {
  expiry_date: string
  requested_at?: string
  type: ValuationType
  id: number
  price: string
  price_currency: Currency
}

export interface ExtractedData {
  has_updates?: boolean
  changed_securities?: number
  unchanged_securities?: number
  matched_documents?: number
  unmatched_documents?: number
  all_documents_uploaded?: boolean
  template_duplicate_id?: number
  template_duplicate_name?: string
  documents?: string[]
}

export interface FeatureFlagUser {
  key: string
  email: string
  name: string
  is_demo?: boolean
}

export interface FeeEntry {
  id?: number | null
  cap?: number | null
  capdesk_percentage?: number | null
  flat_fee?: number | null
  payer_type?: number | null
  liquidity_event_id: number
  volume_upper_bound?: number | null
  _destroy?: boolean
}

export interface Filing {
  id: number
  company_id: number
  translated_type: string
  is_online: boolean
  eligible_for_direct_filing: boolean
  submission_number?: number
  rejection_reason?: string
  has_child_filings?: boolean
  child_filings?: Filing[]
  reference1?: string | null
  filing_status: FlowableFilingStatus
  statement_data?: StatementData
  type: FilingType
  nil_return?: boolean | null
  start_date?: string | null
  end_date?: string | null
  filed?: string | null
  rejected?: string | null
  created_at: string
  approved?: string | null
  documents?: Document[]
  report?: {
    url: string
    title_with_extension: string
  } | null
  request_id: number | null
  security_plan?: {
    id: number
    name: string
    security_plan_type: number
    type: string
  } | null
  eis_aa?: {
    filed?: string | null
    reference1?: string
    created_at: string
    approved?: string | null
  }
  eis1?: {
    filing_status: FlowableFilingStatus
    reference1?: string
    filed?: string | null
    rejected?: string | null
    created_at: string
    approved?: string | null
  }
  eis2?: {
    reference1?: string
    created_at: string
    approved?: string | null
  }
  seis_aa?: {
    filed?: string | null
    reference1?: string
    created_at: string
    approved?: string | null
  }
  seis1?: {
    filing_status: FlowableFilingStatus
    reference1?: string
    filed?: string | null
    rejected?: string | null
    created_at: string
    approved?: string | null
  }
  seis2?: {
    reference1?: string
    created_at: string
    approved?: string | null
  }
  share_transactions?: Array<{
    buyer_name?: string
    transactioned?: string
    quantity?: string
  }>
  flows?: Flow[]
  data?: ReportElement[]
  ch_status?: Array<Record<string, unknown>>
}

export enum FilingAuthority {
  TAX = 0,
  REGISTRY = 1,
}

export interface FilingPreviewResponse {
  preview_url: string
}

export interface FilingResponse {
  processing_id?: string
}

export interface FilingsParams {
  filing_type: PeopleRegisterFilingType
  people_register_entry_id?: number
  people_register_entry_type?: PeopleRegisterEntryType
}

export enum FilingStatus {
  GENERATED = 0,
  FILED = 1,
  REJECTED = 2,
  APPROVED = 3,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export enum FilingType {
  AP01 = 'Reporting::Filing::Registry::Gb::Ap01',
  AP02 = 'Reporting::Filing::Registry::Gb::Ap02',
  AP03 = 'Reporting::Filing::Registry::Gb::Ap03',
  AP04 = 'Reporting::Filing::Registry::Gb::Ap04',
  CH01 = 'Reporting::Filing::Registry::Gb::Ch01',
  CH02 = 'Reporting::Filing::Registry::Gb::Ch02',
  CH03 = 'Reporting::Filing::Registry::Gb::Ch03',
  CH04 = 'Reporting::Filing::Registry::Gb::Ch04',
  CS01 = 'Reporting::Filing::Registry::Gb::Cs01',
  PSC01 = 'Reporting::Filing::Registry::Gb::Psc01',
  PSC02 = 'Reporting::Filing::Registry::Gb::Psc02',
  PSC03 = 'Reporting::Filing::Registry::Gb::Psc03',
  PSC04 = 'Reporting::Filing::Registry::Gb::Psc04',
  PSC05 = 'Reporting::Filing::Registry::Gb::Psc05',
  PSC06 = 'Reporting::Filing::Registry::Gb::Psc06',
  PSC07 = 'Reporting::Filing::Registry::Gb::Psc07',
  PSC08 = 'Reporting::Filing::Registry::Gb::Psc08',
  PSC09 = 'Reporting::Filing::Registry::Gb::Psc09',
  SH01 = 'Reporting::Filing::Registry::Gb::Sh01',
  SH02 = 'Reporting::Filing::Registry::Gb::Sh02',
  SH06 = 'Reporting::Filing::Registry::Gb::Sh06',
  TM01 = 'Reporting::Filing::Registry::Gb::Tm01',
  TM02 = 'Reporting::Filing::Registry::Gb::Tm02',
  CSOP_ANNUAL_RETURN = 'Reporting::Filing::Tax::Gb::CsopAnnualReturn',
  EIS1 = 'Reporting::Filing::Tax::Gb::Eis::Eis1',
  EIS2 = 'Reporting::Filing::Tax::Gb::Eis::Eis2',
  EIS_AA = 'Reporting::Filing::Tax::Gb::Eis::EisAa',
  EMI_ANNUAL_RETURN = 'Reporting::Filing::Tax::Gb::EmiAnnualReturn',
  EMI_NOTIFICATION = 'Reporting::Filing::Tax::Gb::EmiNotification',
  OTHER_ERS_ANNUAL_RETURN = 'Reporting::Filing::Tax::Gb::OtherErsAnnualReturn',
  SEIS1 = 'Reporting::Filing::Tax::Gb::Seis::Seis1',
  SEIS2 = 'Reporting::Filing::Tax::Gb::Seis::Seis2',
  SEIS_AA = 'Reporting::Filing::Tax::Gb::Seis::SeisAa',
}

export enum FinancialExpectationStatus {
  MISSED_EXPECTATIONS = 0,
  MET_EXPECTATIONS = 1,
  EXCEEDED_EXPECTATIONS = 2,
}

export enum FinancialModel {
  BLACK_SCHOLES = 0,
  MONTE_CARLO = 1,
  BINOMIAL = 2,
  BLACK_SCHOLES_WITHOUT_DIVIDENDS = 3,
  OTHER = 999,
}

export type Flow = BaseFlow & {
  current_child_flow?: BaseFlow
  parent_flow?: BaseFlow
}

export interface Flowable {
  buyer?: FlowableBuyer
  debt_id?: number
  debt_type?: DebtType
  filing_status?: FlowableFilingStatus
  flowable_id: number
  id: number
  initial_stakeholder?: FlowableLegalEntity
  order?: FlowableOrder
  quantity?: string
  security_grant_id?: number
  share_class_name?: string
  status?: number
  translated_type?: string
  type: string
}

export interface FlowableBuyer {
  first_name: string
  last_name: string
  legal_name: string
  legal_entity_type: LegalEntityType
}

export enum FlowableCertificateStatus {
  OFFLINE = -1,
  DRAFT = 0,
  REGISTERED = 1,
  SUPERSEDED = 2,
  IN_SIGNING = 1000,
  SIGNED = 1001,
  CANCELLED = 1002,
}

export enum FlowableFilingStatus {
  GENERATED = 0,
  FILED = 1,
  REJECTED = 2,
  APPROVED = 3,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export interface FlowableLegalEntity {
  id: number
  legal_name: string
  registered_entity_type?: string
  registered_entity_id?: number
}

export enum FlowableLiquidityEventStatus {
  GENERATING_PARTICIPANTS = 0,
  DRAFT = 1,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export interface FlowableOrder {
  id: number
  type: string
  created_at: string
  stakeholder?: FlowableLegalEntity
  issuer?: FlowableLegalEntity
}

export enum FlowableOrderExecutionStatus {
  DRAFT = 0,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export enum FlowableOrderStatus {
  DRAFT = 0,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export enum FlowableStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export enum FlowAcceptanceFlowStateBase {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  AWAIT_ACCEPTANCE = 0,
}

export enum FlowConversionOrderExecutionState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PROCESSING_DOCUMENTS = 100,
  PUBLISHING_SIGNING_PACKAGE = 110,
  STAKEHOLDER_SIGNING = 120,
  ISSUER_SIGNING = 125,
  COMPLETING_SIGNING = 130,
  AWAITING_PAYMENT_INSTRUCTIONS = 135,
  AWAITING_SIGNING = 137,
  AWAITING_OTHERS = 150,
  ISSUER_APPROVING = 155,
  PUBLISHING_TRANSACTIONS = 170,
  CANCELLATION_INITIATED = 200,
  REFUNDING = 210,
}

export enum FlowEis3State {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  CREATING_DOCUMENTS = 0,
  PUBLISHING_SIGNING_PACKAGE = 1,
  ISSUER_SIGNING = 2,
  PUBLISHING = 3,
}

export enum FlowIssuanceOrderExecutionState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PROCESSING_DOCUMENTS = 0,
  PUBLISHING_SIGNING_PACKAGE = 1,
  STAKEHOLDER_SIGNING = 2,
  ISSUER_SIGNING = 3,
  PUBLISHING = 4,
  SCHEDULED_FOR_PUBLISHING = 5,
}

export enum FlowOrderExecutionState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PROCESSING_DOCUMENTS = 100,
  PUBLISHING_SIGNING_PACKAGE = 110,
  STAKEHOLDER_SIGNING = 120,
  ISSUER_SIGNING = 125,
  COMPLETING_SIGNING = 130,
  AWAITING_PAYMENT_INSTRUCTIONS = 135,
  AWAITING_SIGNING = 137,
  AWAITING_OTHERS = 150,
  PUBLISHING_TRANSACTIONS = 170,
  CANCELLATION_INITIATED = 200,
  REFUNDING = 210,
}

export enum FlowOrderState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PROCESSING_DOCUMENTS = 0,
  PUBLISHING_SIGNING_PACKAGE = 1,
  STAKEHOLDER_SIGNING = 2,
  AWAITING_EXECUTION = 3,
}

export interface Flows {
  values: Flow[]
  total_count: number
}

export enum FlowSeis3State {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  CREATING_DOCUMENTS = 0,
  PUBLISHING_SIGNING_PACKAGE = 1,
  ISSUER_SIGNING = 2,
  PUBLISHING = 3,
}

export enum FlowShareCertificateSigningState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PUBLISHING_SIGNING_PACKAGE = 0,
  ISSUER_SIGNING = 1,
  PUBLISHING = 2,
}

export interface FlowSignatoryParty {
  type: ActorPartyType
  stakeholder: LightStakeholder
}

export enum FlowSignatureState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  AWAITING_SIGNATORY_DETAILS = 0,
  AWAITING_SIGNATORY_SIGNATURE = 1,
  AWAITING_WITNESS_SIGNATURE = 2,
}

export enum FlowState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
}

export interface FlowStateInfo {
  description: string | null
  details: string | null
  title: string
}

export enum FlowStatus {
  FLOW_OPEN = 1,
  FLOW_CLOSED = 2,
}

export interface FlowTimelineEvent {
  transitioned_at?: string | null
  halt_info?: {
    description: string
    details: string
  } | null
  assigned_stakeholder?: {
    id?: number
    legal_name?: string
  } | null
  assigned_stakeholder_role: number
  assigned_name?: string
  assigned_email?: string
  status: TaskStatus
  task_type: TaskType
  is_current?: boolean
}

export enum FlowTransactionSetState {
  FAILED = -3,
  COMPLETED = -2,
  CANCELLED = -1,
  PLACING_ORDERS = 0,
  DRAFTING_TRANSACTIONS = 1,
  PROCESSING_DOCUMENTS = 2,
  PUBLISHING_SIGNING_PACKAGE = 3,
  ISSUER_SIGNING = 4,
  COMPLETING_SIGNING = 5,
  ISSUER_APPROVING = 6,
  FILING = 8,
  PUBLISHING_TRANSACTIONS = 9,
  CLEARING = 11,
  CAPDESK_FUNDING = 12,
}

export enum FlowType {
  STAKEHOLDER_MERGE_ACCEPTANCE = 'Actor::Stakeholder::Flow::MergeStakeholderAcceptance',
  DOCUMENT_SIGNATURE = 'Document::Signature::Flow::Signature',
  REPORTING_EIS3_SIGNING = 'Reporting::Filing::Tax::Gb::Eis::Flow::Eis3Signing',
  REPORTING_SEIS3_SIGNING = 'Reporting::Filing::Tax::Gb::Seis::Flow::Seis3Signing',
  DEBT_ISSUANCE_ORDER_EXECUTION = 'Security::Debt::Flow::IssuanceOrderExecution',
  SECURITY_ACCEPTANCE = 'Security::Flow::AcceptanceFlow',
  GRANT_CONVERSION_ORDER_EXECUTION = 'Security::Grant::Flow::ConversionOrderExecution',
  GRANT_ISSUANCE_ORDER_EXECUTION = 'Security::Grant::Flow::IssuanceOrderExecution',
  LIQUIDITY_EVENT_ORDER = 'Security::LiquidityEvent::Flow::Order',
  LIQUIDITY_EVENT_ORDER_EXECUTION = 'Security::LiquidityEvent::Flow::OrderExecution',
  LIQUIDITY_EVENT_PURCHASE_ORDER_EXECUTION = 'Security::LiquidityEvent::Flow::PurchaseOrderExecution',
  LIQUIDITY_EVENT_SALES_ORDER_EXECUTION = 'Security::LiquidityEvent::Flow::SalesOrderExecution',
  LIQUIDITY_EVENT_TRANSACTION_SET = 'Security::LiquidityEvent::Flow::TransactionSet',
  PAYMENT_ORDER_EXECUTION = 'Security::Payment::Flow::OrderExecution',
  SHARE_CERTIFICATE_WITNESSED_SIGNING = 'Security::Share::Certificate::Flow::WitnessedShareCertificateSigning',
  SHARE_CERTIFICATE = 'Security::Share::Certificate::ShareCertificate',
  VAL231_SIGNING = 'Security::Valuation::Flow::Val231',
}

export interface FundingRound {
  id: number
  start_date?: string
  end_date?: string
  name: string
  draft_transaction_count?: number
  fully_diluted?: string
  post_money_value?: string
  transaction_count?: number
  shares_issued?: string
  share_price?: string
  amount_raised?: string
  fully_diluted_pre_split?: string
  share_price_pre_split?: string
  shares_issued_pre_split?: string
  priority_key: number | null
}

export enum GrantholderAccessLevel {
  RESTRICTED = 1,
  BASIC = 2,
  ADVANCED = 3,
}

export enum GrantholderConversionStatus {
  IN_EXERCISE_WINDOW = 0,
  WITH_PENDING_EXERCISE = 1,
  WITH_ACTIVE_EXERCISE = 2,
  WITH_INACTIVE_EXERCISE = 3,
}

export enum GrantQuantityStatus {
  CUSTOM = 0,
  YET_TO_VEST_OR_VESTED = 1,
  OUTSTANDING = 2,
  VESTED = 3,
}

export enum GrantReason {
  NEW_HIRE = 0,
  PROMOTION = 1,
  ROLE_CHANGE = 2,
  MERIT = 3,
  RETENTION = 4,
  REFRESH = 5,
}

export enum GrantRole {
  GRANTHOLDER_AND_ISSUER = -99,
  SYSTEM = -1,
  USER = 0,
}

export enum GrantStatus {
  ACTIVE = 0,
  INACTIVE = 1,
  TERMINATING = 2,
  TERMINATION_SCHEDULED = 3,
  TERMINATED = 4,
  REVOKED = 5,
}

export enum HmrcSchemeType {
  EIS = 0,
  SEIS = 1,
}

export interface HrIntegration {
  status?: HrIntegrationStatus
  sync_status?: HrIntegrationSyncStatus
  available_external_fields?: Array<{
    id: string
    name: string
  }>
  metadata?: {
    merge_integration_type?: string
  }
  statistics?: {
    approved: HrIntegrationStatisticsByStatus
    failed: HrIntegrationStatisticsByStatus
    pending: HrIntegrationStatisticsByStatus
    processing: HrIntegrationStatisticsByStatus
    rejected: HrIntegrationStatisticsByStatus
  }
  id?: number
  api_key?: string
  company_id?: number
  type?: string
  field_mapping?: Record<string, unknown>
  autosync_config?: Record<string, unknown>
  last_synced_at?: string
  supported_stakeholder_types?: Record<string, unknown>
}

export interface HrIntegrationAutosyncAudienceValues {
  countries_with_employees: string[]
  countries_without_employees: string[]
  employment_types: string[]
  departments: string[]
}

export enum HrIntegrationAutosyncType {
  UNCONFIGURED = 0,
  ALL_EMPLOYEES = 1,
  CUSTOM = 2,
}

export interface HrIntegrationConnection {
  id: number
  type: string
  status: HrIntegrationStatus
  metadata?: {
    merge_integration_type?: string
  }
}

export interface HrIntegrationStatisticsByStatus {
  double_match: number
  existing: number
  no_match: number
  partial_match: number
}

export enum HrIntegrationStatus {
  ACTIVE = 'active',
  AVAILABLE = 'available',
  CONFIGURING = 'configuring',
  UNAVAILABLE = 'unavailable',
}

export enum HrIntegrationSyncStatus {
  PENDING = 0,
  SYNCING = 1,
  ERROR = 2,
  HEALTHY = 3,
}

export type IdValueSet = Array<{
  id: string
  name: string
  value: number
}>

export interface ImplementationManager {
  id: number
  legal_name: string
  email: string
  calendar_book_url: string
  stakeholder_id: number | null
}

export interface IncentivePools {
  authorized: string
  available: string
  company_id: number
  converted: string
  created_at: string
  deferred: string
  id: number
  outstanding: string
  updated_at: string
  vested: string
}

export interface IncentivePoolStatistics {
  quantity?: StatisticsQuantity
  counts?: {
    authorization_count: number
    total: number
  }
}

export interface IndexCompany {
  id: number
  about?: string
  company_name?: string
  country?: string
  email?: string
  registration_number?: string
  parent_company_country?: string
  parent_company_registration_number?: string
  parent_company_name?: string
  vehicle_id?: string
  type?: string
  unique_taxpayer_reference?: string
  seller_document_upload_url?: string
  display_country?: string
  display_country_name?: string
  display_registration_number?: string
  display_name?: string
  portfolio_company_name?: string
  deferred_share_class?: boolean
  is_active?: boolean
  not_live: boolean
  has_liquidity_events?: boolean
  has_liquidity_events_in_progress?: boolean
  has_signatures_in_progress?: boolean
  country_name?: string
  account_status_message?: string
  created_at: string
  formation_date?: string
  from_template_id?: number
  is_demo?: boolean
  is_template?: boolean
  paye_reference_number?: string
  updated_at: string
  website?: string
  managed_by_company_id?: number
  eis_knowledge_intensive?: boolean
  has_multiple_currencies?: boolean
  modules_debts_enable?: boolean
  modules_email_stakeholders_enable?: boolean
  modules_options_enable?: boolean
  modules_phantom_shares_enable?: boolean
  modules_share_grants_enable?: boolean
  modules_warrants_enable?: boolean
  modules_rsus_enable?: boolean
  config_enable_company_emi_limit: boolean
  config_enable_individual_emi_limit: boolean
  config_enable_eis: boolean
  config_enable_emi_share_plan_delivery: boolean
  config_enable_equity_management?: boolean
  config_enable_open_tasks_digest_notification?: boolean
  config_enable_employee_notifications?: boolean
  enable_equity_calculator_for_grantholders: boolean
  enable_portfolio_public_valuations_for_grantholders: boolean
  enable_portfolio_public_valuations_for_investors: boolean
  config_enable_seis: boolean
  enable_shareholder_funding_round_access: boolean
  config_enable_grantholder_signatory_only?: boolean
  config_enable_online_buybacks: boolean
  config_enable_online_secondaries: boolean
  config_signature_deadline_in_days?: number
  config_force_stakeholder_sync?: boolean
  config_news_allow_news_from_portfolio_company?: boolean
  config_notify_on_stakeholder_sync?: boolean
  config_require_2fa?: boolean
  config_shares_enable_multiple_share_number_series?: boolean
  config_shares_enable_share_numbers?: boolean
  config_shares_enable_shareholder_register?: boolean
  config_share_certificates_enable?: boolean
  config_share_certificates_by_share_class?: boolean
  config_share_certificates_initial_number?: number
  investor_captable_access_restricted_reason?: string
  is_share_certificates_generated?: boolean
  config_show_in_portfolios: boolean
  config_linked_accounts?: string
  config_watermark_share_certificates: boolean
  emi_enable?: boolean
  requires_emails_confirmation?: boolean
  config_enable_valuation_requests?: boolean
  config_enable_company_registers_and_filings: boolean
  legal_name?: string
  cover_photo_url?: string
  has_cover_photo?: boolean
  thumbnail?: string
  logo_exists?: boolean
  cover_exists?: boolean
  is_new?: boolean
  is_processing_share_certificates?: boolean
  has_certificates_in_signing?: boolean
  stakeholder_id?: number
  has_exercise_approver?: boolean
  share_certificate_template_id?: number
  share_certificate_url?: string
  securities_approver_count: number
  custom_valuation_in_user_default_currency?: number
  config_use_own_signature_service: boolean
  config_enable_companies_house_filing?: boolean
  link_to_companies_house_dismissed?: boolean
  benchmarks_last_versioned_at?: string
  has_subsidiaries?: boolean
  recent_events?: string
  overview?: string
  migrated_to_cw?: boolean
  address1?: string | null
  address2?: string | null
  city?: string | null
  phone?: string | null
  postcode?: string | null
  region?: string | null
  ch_presenter_id?: string | null
  ch_company_auth_code?: string | null
  currency_if_unique?: Currency
  currency?: Currency
  go_live_date?: string | null
  comparable_companies?: string[]
  cosec_activation_completed_at?: string | null
  config_investor_captable_access_level: CaptableAccessLevel
  config_grantholder_access_level: GrantholderAccessLevel
  feature_flag_user?: FeatureFlagUser
  decimal_precision_needed: DecimalPrecision
  account_status_reason: AccountStatusReason
  user_authorizations?: Authorization[]
  legal_entity_type?: LegalEntityType
  terminology_settings: TerminologySettings
  vehicle_type?: VehicleType
  account_status: AccountStatus
  juridical_person_category: JuridicalPersonCategory
  custom_valuation?: CustomValuation | null
}

export interface IndexConvertedFrom {
  id: number
  type: string
  debt_type?: DebtType
}

export interface IndexShareRegisterEntryDetails {
  type: ShareRegisterType
  status: ShareRegisterStatus
  filing_status?: AllotmentFilingStatus
}

export type IndexShareTransaction = CommonShareTransaction &
  IndexShareTransactionGroupedByBuyer & {
    basic_modifications_allowed: boolean
    is_flow_in_progress?: boolean
    transaction_set_id?: number
    quantity_balance?: number
    share_class: TransactionShareClass
    converted_from?: IndexConvertedFrom
    share_register_entry?: IndexShareRegisterEntryDetails
    s_eis_investment_details?: SEISInvestmentDetails
  }

export interface IndexShareTransactionGroupedByBuyer {
  legal_name?: string
  transactions_draft_count?: number
  transactions_publish_count?: number
  transactions_revoked_count?: number
  founding_round_names?: string[]
  security_transaction_ids?: number[]
}

export interface IndexStatusItem {
  id: number
  type: string
  exclude_drafts?: boolean
  archived_at: string | null
  itemable_id: number
  deadline: string
  archived: boolean
  completed_at: string | null
  additional_info?: string
  valuation_missing?: string
  status: StatusItemStatus
}

export interface IndividualConversionDocumentSet {
  id: number
  name: string
}

export interface IndividualIssuanceDocumentSet {
  id: number
  name: string
}

export interface IndustryCode {
  id: number
  company_id: number
  code: string
  created_at: string
  start_date: string
  description?: string
  end_date?: string
}

export interface IndustryCodePostPayload {
  code: string
  start_date?: string
}

export interface IndustryCodePutPayload {
  end_date: string
}

export interface IntegrationRequest {
  status: IntegrationRequestStatus
  match_type: IntegrationRequestMatchType
  request_type: IntegrationRequestType
  sync_type?: IntegrationRequestSyncType
  changed_fields?: string[]
  request_errors?: Array<{
    attribute?: string
    errors?: string[]
  }>
  id: number
  created_at: string
  creator: string
  external_id: string
  prepared_data: Record<string, unknown>
  updated_at: string
  updater: string
  request_legal_name?: string
  request_email?: string
  request_personal_email?: string
  stakeholder_legal_name?: string
  stakeholder_email?: string
  stakeholder_id?: number
  employee_id?: string
  employment_type?: string
  previous_created_at?: string
  updated_by?: string
}

export interface IntegrationRequestIndexSchema {
  values: IntegrationRequest[]
  total_count: number
}

export enum IntegrationRequestMatchType {
  NO_MATCH = 0,
  PARTIAL_MATCH = 1,
  EXISTING = 2,
  DOUBLE_MATCH = 3,
}

export enum IntegrationRequestStatus {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
  FAILED = 3,
  PROCESSING = 4,
}

export enum IntegrationRequestSyncType {
  CREATE = 0,
  PAIR = 1,
  UPDATE = 2,
}

export enum IntegrationRequestType {
  ONBOARD_EMPLOYEE = 0,
  UPDATE_EMPLOYEE = 1,
}

export interface InternalDocumentIndex {
  id: number
  name: string
  created_at: string
  updated_at: string
  creator_id: string
  updater_id: string
  creator_name: string
  updater_name: string
  read_only: boolean
  archivable: boolean
  folder_documents_count?: number
  file_extension?: string
  file_url?: string
  file_size?: number
  type: InternalDocumentType
  folder_status: DocumentFolderStatus
  folder_type: DocumentFolderType
}

export enum InternalDocumentType {
  DOCUMENT = 'Document::Document',
  DOCUMENT_FOLDER = 'Document::DocumentFolder',
}

export interface Investment {
  agg_cash_settlement_payout_factor?: string | null
  agg_cost: string
  agg_invested: string
  agg_invested_in_user_default_currency: string | null
  agg_price: string
  agg_quantity?: string
  agg_quantity_for_estimated_value?: string | null
  agg_quantity_incl_deferred?: string
  agg_realised_value_in_user_default_currency: string
  agg_unvested_quantity?: string
  agg_vested_quantity?: string
  agg_vested_quantity_excl_converted?: string | null
  agg_votes: string
  cancelled_quantity?: string
  company_feature_flag_user: FeatureFlagUser
  company_id: number
  company_name: string
  company_terminology_settings: TerminologySettings
  conversion_price?: string
  conversion_price_currency?: Currency
  conversion_price_in_user_default_currency?: string
  converted_percentage?: string
  converted_quantity?: string
  debt_id: number | null
  debt_type: DebtType | null
  debt_unrealised_value?: string
  estimated_unvested_value?: string | null
  estimated_value?: string | null
  estimated_value_calculation_method?: ValuationCalculationMethod
  estimated_value_currency?: Currency | null
  estimated_vested_value?: string | null
  estimated_vested_value_excl_converted?: string | null
  group_issued: string | null
  id: number
  in_draft: boolean
  investor_id: number
  is_2fa_required: boolean
  is_hurdle_valuation: boolean
  is_online: boolean
  is_terminating: boolean | null
  is_deferred: boolean
  issued_quantity?: string
  issued_shares_plan_id: number | null
  price_currency: Currency
  price_in_user_default_currency?: string
  security_grant_id: number | null
  security_plan: SecurityPlan | null
  security_type: string
  security_types?: string[]
  share_class_id: number
  share_class_name: string
  should_sign: boolean
  signature_deadline?: string | null
  signature_id?: number
  signature_model_id?: number
  signature_type?: string
  valuation_enabled: boolean
  valuation_value?: string
}

export interface InvestmentIndex {
  total_count: number
  values: Investment[]
}

export interface InvestmentSet {
  security_types: string[]
  share_class_ids: number[]
  share_class_names: string[]
  debt_types: DebtType[]
  investor: ShowStakeholder
  share_class_details: InvestmentSetShareClassDetails[]
  id: number
  company_id: number
  investor_id: number
  agg_quantity: string
  agg_price: string
  agg_cost: string
  agg_votes: string
  agg_quantity_incl_deferred: string
  agg_ownership_quantity: string
  is_current_user_investment: boolean
}

export interface InvestmentSetIndex {
  values: InvestmentSet[]
  total_count: number
  grouped_counts?: {
    employee_equity: EmployeeEquity
  }
}

export interface InvestmentSetShareClassDetails {
  security_types: string[]
  debt_types: DebtType[]
  share_class_id: number
  share_class_name: string
  agg_quantity: number
  agg_ownership_quantity: number
  agg_votes: number
  has_shares: boolean
  has_share_grants: boolean
}

export type JobLevels = Record<string, string[]>;

export enum JobTrack {
  INDIVIDUAL_CONTRIBUTOR = 0,
  MANAGER = 1,
  EXECUTIVE = 2,
}

export enum JuridicalPersonCategory {
  COMPANY_OPERATING = 1,
  COMPANY_INVESTING = 2,
  VEHICLE_ALL = 3,
}

export interface LastAdminAction {
  action_date: string
  reason: AdminActionReason
  created_by: string
  secondary_reason?: number
  description: string
}

export interface LegalConsentor {
  email: string
  first_name: string
  last_name: string
}

export enum LegalEntityType {
  LEGAL_PERSON = 0,
  LEGAL_COMPANY = 1,
  LEGAL_VEHICLE = 2,
}

export type LightAdministrator = LightStakeholder & {
  administrator_title: string
  latest_generated_report_types: ReportType[]
  administrator_details_confirmation_required: boolean
  administrator_role: AdministratorRole
  from: string
  full_access_read: boolean
  full_access_write: boolean
  is_administrator_company_secretary: boolean
  is_administrator_external: boolean
  is_registered: boolean
  is_staff_stakeholder: boolean
  registered_entity_id: number | null
  registered_entity_type: string | null
  verified: boolean
}

export interface LightCompany {
  company_name: string
  country: string
  email: string
  id: number
  registration_number: string
  legal_name: string
  address1: string | null
  address2: string | null
  city: string | null
  phone: string | null
  postcode: string | null
  region: string | null
}

export type LightInvestor = LightStakeholder & {
  controlled_attributes?: string[]
  contact_email?: string
  is_anonymized?: boolean
  bkey?: string
}

export interface LightPoolAuthorization {
  id: number
  name: string
  authorized: string
  quantity: number
}

export interface LightResolution {
  id: number
  name: string
  date_adopted: string
}

export interface LightSecurityPlan {
  id: number
  name: string
  individual_issuance_document_set: IndividualIssuanceDocumentSet
}

export interface LightShareClass {
  id: number
  name: string
  share_certificate_id?: number
}

export interface LightStakeholder {
  address1?: string | null
  address2?: string | null
  administrator_title?: string
  allow_reinvite: boolean
  bkey?: string
  city?: string | null
  company?: LightCompany
  company_accesses?: CompanyAccess[]
  company_name: string | null
  company_relations: CompanyRelation[]
  compensation_band_id?: number | null
  compensation_score?: CompensationScore | null
  config_grantholder_access_level: GrantholderAccessLevel | null
  config_investor_captable_access_level: CaptableAccessLevel | null
  country: string | null
  country_name: string | null
  created_at: string
  date_of_birth?: string | null
  department?: string | null
  dial_code?: string | null
  display_country: string | null
  display_country_name: string | null
  display_name: string | null
  display_registration_number: string | null
  email: string
  employee_id?: string | null
  employee_lifecycle_status: EmployeeLifecycleStatus | null
  employment_type: string | null
  enable_equity_calculator_for_grantholders: boolean | null
  enable_portfolio_public_valuations_for_grantholders: boolean | null
  enable_portfolio_public_valuations_for_investors: boolean | null
  enable_shareholder_funding_round_access: boolean | null
  equity_ratio?: number | null
  external_stakeholder_id: string | null
  first_name: string | null
  has_draft_transactions?: boolean
  has_online_exercises_in_progress?: boolean
  id: number
  is_active: boolean
  is_anonymized?: boolean | null
  is_merging?: boolean
  is_public: boolean
  is_registered: boolean
  job_level?: string | null
  job_title?: string | null
  job_role?: string | null
  label?: string | null
  last_name: string | null
  legal_entity_type: LegalEntityType
  legal_name: string
  max_equity?: number | null
  max_salary?: number | null
  mid_equity?: number | null
  mid_salary?: number | null
  min_equity?: number | null
  min_salary?: number | null
  middle_name: string | null
  no_transactions?: boolean
  note?: string | null
  ntm_equity?: number | null
  parent_company_country: string | null
  parent_company_name: string | null
  parent_company_registration_number: string | null
  pay_currency?: string | null
  pay_period?: PayPeriodType | null
  pay_rate?: number | null
  personal_email?: string | null
  personal_id?: string | null
  phone_number?: string | null
  pledges_and_liens?: string | null
  portfolio_company_name: string | null
  postcode?: string | null
  region?: string | null
  registered_entity_id: number | null
  registered_entity_type: string | null
  registers_metadata?: StakeholderRegistersMetadata
  registration_number: string | null
  salary?: number
  salary_currency?: string | null
  salary_ratio?: number | null
  stakeholder_category: StakeholderCategory
  stakeholder_classes?: string[]
  stakeholder_type?: string | null
  statistics?: EmployeeStatistics
  start_date?: string | null
  tenure?: number
  termination_date?: string | null
  total_equity?: number | null
  updated_at: string
  vehicle_id: string | null
  vehicle_type: VehicleType | null
}

export enum LimitStatus {
  UNDER_LIMIT = 0,
  MISSING_VALUATION = 1,
  APPROACHING_LIMIT = 2,
  AT_LIMIT = 3,
}

export interface LiquidityEvent {
  id: number
  company_id: number
  type: string
  name: string
  price_currency: Currency
  threshold: number
  fee_entries: FeeEntry[]
  sales_ordering_start: string
  sales_ordering_deadline: string
  clearing_deadline: string
  created_at: string
  allowed_quantity: number
  quantity: string
  published: string
  settled: string
  status: LiquidityEventStatus
  transaction_sets: LiquidityEventTransactionSet[]
  sellers_attributes: SellerAttributes[]
  prices: string
  purchase_ordering_start: string
  purchase_ordering_deadline: string
}

export enum LiquidityEventStatus {
  GENERATING_PARTICIPANTS = 0,
  DRAFT = 1,
  IN_PROGRESS = 1000,
  COMPLETED = 1001,
  CANCELLED = 1002,
}

export interface LiquidityEventTransactionSet {
  id: number
  processable_processing_status: ProcessableProcessingStatus
  flows: Flow[]
}

export enum LongstopValuationIntervalUnit {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
  YEAR = 3,
}

export interface MailTracking {
  created_at: string
  id: number
  mail_types: string[]
  mail_types_translated: string[]
  status: string
  to: string | null
}

export interface ManualEvent {
  id: number
  title: string
  deadline: string
  company_id: number
  creator: string
  updater: string
  created_at: string
}

export interface Member {
  share_classes?: LightShareClass[]
  earliest_published_transaction: MemberTransactionData
  latest_published_transaction: MemberTransactionData
  id: number
  stakeholder_id: number
  total_acquired: number
  total_disposed: number
  balance: number
  created_at: string
  updated_at: string
  membership_start_at: string
  legal_name: string
  membership_start_confirmation_required: boolean
  membership_start_corrected: boolean
  membership_end_corrected: boolean
  membership_start_imprecise: boolean
  membership_end_imprecise: boolean
  membership_end_at?: string
}

export enum MemberBatchActionType {
  CONFIRM_MEMBERSHIP_START_DATE = 0,
}

export interface MemberCeasePutParams {
  membership_end_at: string
}

export interface MemberData {
  earliest_share_register_entry: {
    id: number
    type: string
  }
  latest_share_register_entry: {
    id: number
    type: string
  }
  name: string
  date: string
  stakeholder_id: number
  member_id: number
}

export interface MemberEntryPutParams {
  membership_start_at: string
}

export type MemberPutParams = MemberEntryPutParams | MemberCeasePutParams

export interface Members {
  values: Member[]
  total_count: number
}

export interface MemberStartDateConfirmData {
  member_id: number
  date: string
}

export interface MemberTransactionData {
  id: number
  type: string
  date: string
}

export interface MergeStakeholderAcceptance {
  id: number
  created_at?: string
  state_value?: number
  status?: number
  type: string
  company_name: string
  company_email: string
  winner_email: string
  loser_email: string
}

export interface Metadata {
  dismissed_grant_banner?: Record<string, boolean>
  favourite_pages?: Record<string, string[]>
  saved_table_filters?: Record<string, Record<string, unknown>>
}

export interface MinimumCompanyAccess {
  config: string | null
  level: AccessLevel
  role: AccessRole
}

export type NameValueSet = Array<{
  id: number
  name: string
  share: number
  value: number
}>

export enum NatureOfControl {
  FIRM_PSC_HAS_SIGNIFICANT_CONTROL = 'FIRM_PSC_HAS_SIGNIFICANT_CONTROL',
  PSC = 'PSC',
  TRUST_PSC_HAS_SIGNIFICANT_CONTROL = 'TRUST_PSC_HAS_SIGNIFICANT_CONTROL',
}

export interface News {
  category?: NewsCategory
  documents?: Document[]
  id: number
  company_id: number
  created_at: string
  published?: string
  title?: string
  category_translated?: string
  cover_photo_url?: string
  last_sent?: string
  content?: string
}

export enum NewsCategory {
  GENERAL = 0,
  EVENT = 1,
  PRESS = 2,
  FINANCIAL = 3,
  MARKET = 4,
  SHORT = 5,
  IMPORTANT = 6,
}

export enum NoticeType {
  SECTION_790D = 'SECTION_790D',
  SECTION_790E = 'SECTION_790E',
}

export enum NoTinReason {
  COUNTRY_EXEMPTION = 0,
  LAW_EXEMPTION = 1,
  OTHER = 3,
}

export interface OffboardingStakeholder {
  personal_email: string
  company_name: string
}

export enum OfflinePaymentStatus {
  UNPAID = 0,
  PAID = 1,
}

export enum OmniauthAuthorizationProvider {
  GOOGLE = 'google_oauth2',
  LINKEDIN = 'linkedin',
}

export interface OnboardingData {
  company_id: number
  created_at: string
  data: OnboardingDataJson
  id: number
}

export interface OnboardingDataJson {
  advance_assurance: {
    is_eligible?: boolean
    needs_aa: boolean
    request_type?: AdvanceAssuranceRequestTypeKeys
  }
  share_classes?: Array<{
    approval_date: string
    name: string
    nominal_value: string
    nominal_value_currency: Currency
    rights?: string | null
    votes: number
  }>
  shareholders?: Array<{
    address1?: string
    address2?: string
    city?: string
    country?: string
    email?: string
    legal_entity_type: LegalEntityType
    legal_name: string
    postcode?: string
    region?: string
    registration_number?: string
  }>
  transactions?: Array<{
    price: string
    quantity: number
    shareholder: string
    share_class: string
    transactioned: string
  }>
}

export interface OnboardingDataPostParams {
  company_id: number
  data: OnboardingDataJson
}

export enum OnboardingType {
  STANDARD = 0,
  AUTOMATED = 1,
  INELIGIBLE = 2,
}

export enum OptionPlanType {
  J_GB_EMI = 0,
  J_GB_CSOP = 1,
  J_US_ISO = 2,
  J_US_NSO = 3,
  OTHER = 999,
}

export interface OptionStatistics {
  counts: {
    total: number
    online_count: number
    employment_related_count: number
    grant_count: IdValueSet
  }
  votes: {
    outstanding?: number
    exercised: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  quantity: {
    outstanding: number
    exercised: number
    issued_outstanding: number
    issued_exercised: number
    total: number
    share_class: NameValueSet
  }
  transaction_quantity: {
    share_class: NameValueSet
  }
}

export interface Order {
  approved?: boolean
  company_id?: number
  conversion_cost?: string
  conversion_quantity?: string
  cost?: string
  created_at?: string
  currency?: Currency
  fee?: number
  filing_fee?: string
  final_price?: string
  has_failed_flow?: boolean
  id: number
  max_cost?: string
  max_fee?: number | null
  max_filing_fee?: string
  max_gross_proceeds?: string
  max_quantity?: string | number
  max_transfer_quantity?: string
  may_cancel?: boolean
  order_executions?: ConversionOrderExecution[]
  ordering_allowed_to?: string | null
  price?: string
  quantity?: string
  stakeholder?: LightStakeholder
  status?: number
  transaction_requests?: TransactionRequest[]
  type: string
  issuer?: {
    id: number
    country?: string
    legal_entity_type?: number
    legal_name?: string
    registration_number?: string
    thumbnail?: string
  }
}

export enum OutsideResidencyReason {
  STUDENT = 0,
  WORKING_WITHOUT_LIVING = 1,
  DIPLOMAT_OR_MILITARY = 2,
  RECENT_MOVE = 3,
  OTHER = 4,
}

export enum OwnershipPercentage {
  MORE_OR_EQUAL_75 = 'MORE_OR_EQUAL_75',
  MORE_THAN_25_LESS_THAN_50 = 'MORE_THAN_25_LESS_THAN_50',
  MORE_THAN_50_LESS_THAN_75 = 'MORE_THAN_50_LESS_THAN_75',
}

/**
 * Company ID
 */
export type Parametercompany_path_id = string

/**
 * Generic path ID
 */
export type Parametergeneric_path_id = number

/**
 * News ID
 */
export type Parameternews_path_id = number

/**
 * User ID - can be `current` for current user
 */
export type Parameteruser_path_id = string

export interface ParseDocumentResponse {
  id?: string
}

export interface PartnerCode {
  valid_from?: string
  valid_to: string
  id: number
  code?: string
  code_type: number
  hubspot_id?: string
  partner_name?: string
  description?: string
  discount_percentage?: string
  is_valid?: boolean
  creator?: string
  updater?: string
  discount?: number
}

export interface PartnerCodePostParams {
  valid_from: string
  valid_to: string
  code: string
  partner_name: string
  description?: string
  discount_percentage: string
  hubspot_id?: string
}

export type PartnerCodePutParams = PartnerCodePostParams & {
  id?: number
}

export enum PaymentMethod {
  CARD = 0,
  INVOICE = 1,
}

export enum PayPeriodType {
  EVERY_SIX_MONTHS = 0,
  QUARTERLY = 1,
  MONTHLY = 2,
  SEMIMONTHLY = 3,
  YEARLY = 4,
}

export interface PeopleRegisterEntries {
  values: PeopleRegisterEntry[]
  total_count: number
}

export type PeopleRegisterEntry = PeopleRegisterEntryDetails & {
  status: PeopleRegisterEntryStatus
  id: number
  appointed_at: string
  company_id: number
  created_by: string
  created_at: string
  creator_id: number
  correspondence_address: string
  changed_at?: string
  deleted_on?: string
  terminated_at?: string
  registrable_at?: string
  updated_by?: string
  updated_at?: string
  updater_id?: number
  versions: PeopleRegisterEntryVersion[]
  type: PeopleRegisterEntryType
  stakeholder_registers_metadata?: StakeholderRegistersMetadata
}

export interface PeopleRegisterEntryDetails {
  street: string
  post_town: string
  county: string
  building_name: string
  country: string
  postcode: string
  identity_verified: boolean
  business_occupation?: string
  corporate_governing_law?: string
  corporate_legal_form?: string
  corporate_name?: string
  corporate_registered?: string
  corporate_registration_number?: string
  date_of_birth?: string
  date_of_board_approving_appointment?: string
  identity_verification_number?: string
  individual_first_name?: string
  individual_last_name?: string
  individual_title?: string
  nationality?: string
  residential_street?: string
  residential_post_town?: string
  residential_county?: string
  residential_building_name?: string
  residential_country?: string
  residential_postcode?: string
  section243_exemption?: boolean
  stakeholder_id?: number
  right_to_appoint_and_remove_directors?: boolean
  significant_influence_or_control?: boolean
  section790zf_exemption?: boolean
  rle_register_country?: string
  register_entry_changed_at?: string
  register_entry_terminated_at?: string
  uses_company_registered_office?: boolean
  individual_former_names?: Array<{
    first_name?: string
    last_name?: string
  }>
  voting_rights?: OwnershipPercentage
  ownership_of_shares?: OwnershipPercentage
  nature_of_control?: NatureOfControl
}

export interface PeopleRegisterEntryDetailsAttributes {
  individual_first_name?: string
  individual_last_name?: string
  individual_title?: string
  building_name?: string
  street?: string
  post_town?: string
  county?: string
  residential_building_name?: string
  residential_street?: string
  residential_post_town?: string
  residential_county?: string
  residential_postcode?: string
  residential_country?: string
  nationality?: string
  date_of_birth?: string
  business_occupation?: string
  section243_exemption?: boolean
  postcode?: string
  country?: string
  corporate_governing_law?: string
  corporate_legal_form?: string
  corporate_name?: string
  corporate_registered?: string
  corporate_registration_number?: string
  date_of_board_approving_appointment?: string
  stakeholder_id?: number
  uses_company_registered_office?: boolean
  identity_verification_number?: string
  individual_former_names?: Array<{
    first_name?: string
    last_name?: string
  }>
}

export enum PeopleRegisterEntryDirectorType {
  CORPORATE_GB = 'Actor::Company::PeopleRegisterEntry::Types::DirectorCorporateGb',
  CORPORATE_NON_GB = 'Actor::Company::PeopleRegisterEntry::Types::DirectorCorporateNonGb',
  INDIVIDUAL = 'Actor::Company::PeopleRegisterEntry::Types::DirectorIndividual',
}

export type PeopleRegisterEntryFilingType = DirectorFilingType | SecretaryFilingType | PscFilingType

export interface PeopleRegisterEntryPostParams {
  details_attributes?: PeopleRegisterEntryDetailsAttributes
  filings?: FilingsParams[]
  status?: number
  appointed_at?: string
  terminated_at?: string
  consent_to_act?: boolean
}

export enum PeopleRegisterEntryPSCType {
  INDIVIDUAL_PERSON_WITH_SIGNIFICANT_CONTROL = 'Actor::Company::PeopleRegisterEntry::Types::IndividualPersonWithSignificantControl',
  OTHER_REGISTRABLE_PERSON = 'Actor::Company::PeopleRegisterEntry::Types::OtherRegistrablePerson',
  RELEVANT_LEGAL_ENTITY = 'Actor::Company::PeopleRegisterEntry::Types::RelevantLegalEntity',
}

export interface PeopleRegisterEntryPutParams {
  details_attributes?: PeopleRegisterEntryDetailsAttributes
  filings?: FilingsParams[]
  id?: number
  changed_at?: string
  terminated_at?: string
}

export enum PeopleRegisterEntrySecretaryType {
  CORPORATE_GB = 'Actor::Company::PeopleRegisterEntry::Types::SecretaryCorporateGb',
  CORPORATE_NON_GB = 'Actor::Company::PeopleRegisterEntry::Types::SecretaryCorporateNonGb',
  INDIVIDUAL = 'Actor::Company::PeopleRegisterEntry::Types::SecretaryIndividual',
}

export enum PeopleRegisterEntryStatus {
  ACTIVE = 0,
  RESIGNED = 1,
}

export type PeopleRegisterEntryType =
  | PeopleRegisterEntrySecretaryType
  | PeopleRegisterEntryDirectorType
  | PeopleRegisterEntryPSCType

export type PeopleRegisterEntryVersion = PeopleRegisterEntryDetails & {
  version_id: number
}

export type PeopleRegisterFilingType = SecretaryFilingType | DirectorFilingType | PscFilingType

export enum PersonStatement {
  UNCONFIRMED_REGISTRABLE_PERSON = 'UNCONFIRMED_REGISTRABLE_PERSON',
  UNIDENTIFIED_REGISTRABLE_PERSON = 'UNIDENTIFIED_REGISTRABLE_PERSON',
}

export interface PersonWithSignificantControlDetailsAttributes {
  individual_first_name?: string
  individual_last_name?: string
  individual_title?: string
  building_name?: string
  street?: string
  post_town?: string
  county?: string
  postcode?: string
  country?: string
  residential_building_name?: string
  corporate_governing_law?: string
  corporate_legal_form?: string
  corporate_name?: string
  corporate_registered?: string
  corporate_registration_number?: string
  ownership_of_shares?: string
  voting_rights?: string
  right_to_appoint_and_remove_directors?: boolean
  significant_influence_or_control?: boolean
  section790zf_exemption?: boolean
  rle_register_country?: string
  register_entry_changed_at?: string
  register_entry_terminated_at?: string
  stakeholder_id?: number
  uses_company_registered_office?: boolean
  nature_of_control: string
  individual_former_names?: Array<{
    first_name?: string
    last_name?: string
  }>
}

export type PersonWithSignificantControlFilingParams = CommonFilingParams & {
  filing_type?: PscFilingType
  register_entry_changed_at?: string | null
  register_entry_terminated_at?: string | null
  identity_verification_number?: string
}

export interface PersonWithSignificantControlPostParams {
  details_attributes?: PersonWithSignificantControlDetailsAttributes
  filings?: FilingsParams[]
  terminated_at?: string
  status: number
  appointed_at: string
  registrable_at: string
}

export interface PersonWithSignificantControlPreviewTerminateParams {
  filings: FilingsParams[]
  id: number
  date_of_changes: string
  date_of_termination: string
  register_entry_terminated_at: string
}

export interface PersonWithSignificantControlPutParams {
  details_attributes?: PersonWithSignificantControlDetailsAttributes
  filings?: FilingsParams[]
  id?: number
  changed_at?: string
  registrable_at?: string
}

export enum PhantomShareNames {
  PHANTOM_SHARE = 'phantom_share',
  VIRTUAL_SHARE = 'virtual_share',
}

export interface PhantomShareStatistics {
  quantity: {
    authorized: number
    outstanding: number
    deferred: number
    exercised: number
    available: number
    total: number
    share_class: NameValueSet
  }
  counts: {
    total: number
    online_count: number
    employment_related_count: number
    grant_count: IdValueSet
  }
  votes: {
    outstanding?: number
    exercised: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  transaction_quantity: {
    share_class: NameValueSet
  }
}

export enum PlanAuthorizationType {
  NO_AUTHORIZATIONS = 0,
  SHARED_AUTHORIZATIONS = 1,
  OWN_AUTHORIZATIONS = 2,
  ISSUED = 3,
}

export enum PlanPeriodType {
  DAY = 0,
  WEEK = 1,
  MONTH = 2,
  YEAR = 3,
}

export enum PlanStatus {
  PENDING_ADOPTION = 0,
  PENDING_PUBLISHING = 1,
  PUBLISHED = 2,
}

export interface PoolAuthorization {
  authorized: string
  created_at: string
  current_status: PoolAuthorizationStatus
  documents?: Document[]
  id: number
  incentive_pool_id: number
  is_shared_authorization: boolean
  name: string
  note: string | null
  published: string | null
  quantity: string
  registration_class: RegistrationClass
  registration_state: RegistrationState
  registration_state_category: RegistrationStateCategory
  registration_status: RegistrationStatus
  retired: string | null
  revocation_note: string | null
  security_plan?: SecurityPlan
  security_plan_id: number | null
  security_transaction_id: number | null
  updated_at: string
}

export interface PoolAuthorizations {
  total_count: number
  values: PoolAuthorization[]
}

export enum PoolAuthorizationStatus {
  DRAFT = 0,
  PUBLISHED = 1,
  REVOKED = 2,
}

export interface PortfolioCompany {
  company_id: number
  company_name: string
  is_active_stakeholder: boolean
  has_investor_access: boolean
  stakeholder_id: number
  stakeholder_type: StakeholderType
  terminology_settings: TerminologySettings
}

export interface PortfolioItemIndex {
  values: PortfolioItemIndexElement[]
  total_count: number
}

export interface PortfolioItemIndexElement {
  active_stakeholder: boolean
  agg_invested_in_user_default_currency: string
  agg_quantity: number
  agg_share_quantity: number
  agg_value_in_user_default_currency: string
  agg_share_value_in_user_default_currency: string
  agg_votes: number
  agg_share_votes: number
  base_ownership: string | null
  company_account_status: AccountStatus
  company_account_status_reason: AccountStatusReason
  company_id: number
  company_name: string
  company_config_secondaries_enabled: boolean
  country: string
  current_user_investor_access: boolean
  id: number
  invested_history_in_user_default_currency: PortfolioItemInvestedHistory[]
  item_type: string
  company_migrated_to_cw: boolean
  latest_valuation_share_price_in_user_default_currency: string
  offline_investment: unknown | null
  security_types: string[]
  share_class_names: string[]
  stakeholder_id: number
  total_votes?: number
  two_fa_required_and_disabled: boolean
  vehicle_type: VehicleType | null
  company: {
    email: string
    id: number
    legal_name: string
    terminology_settings: TerminologySettings
    thumbnail: string | null
    type: string
  }
}

export interface PortfolioItemInvestedHistory {
  accumulated_estimated_value_quantity?: string
  accumulated_realised_value?: number
  estimated_value: string
  invested: string
  invested_available_for_return: string
  transactioned: string
  transactions_count?: number
  event: {
    invested: number
    quantity: number
    transaction_id: number
    transaction_type: string
    share_price: number
    previous_share_price?: number
  }
}

export interface PortfolioItemShow {
  invested_history_in_user_default_currency: PortfolioItemInvestedHistory[]
  id: number
  fully_diluted_equity?: number
  company_config_require_2fa: boolean
  company_migrated_to_cw: boolean
  company_config_secondaries_enabled: boolean
  agg_debt_interest_in_user_default_currency?: string
  latest_valuation_share_price_in_user_default_currency: string
}

export interface PortfolioOptionV2 {
  legal_name: string
  label: string
  registered_entity_id: number
  legal_entity_type: LegalEntityType
  registered_entity_type: RegisteredEntityType
  portfolio_companies?: PortfolioCompany[]
}

export interface PortfolioStatistics {
  invested_history?: PortfolioStatisticsInvestedHistory[]
  is_2fa_required?: boolean
  agg_invested: string
  agg_value_estimate: string
  agg_share_value_estimate: string
  agg_invested_available_for_return: string
  currency: Currency
}

export interface PortfolioStatisticsInvestedHistory {
  estimated_value: string
  invested: string
  invested_available_for_return: string
  transactioned: string
}

export interface PortfolioTransaction {
  price: string | null
  quantity: string | null
  converted_from_id: number | null
  transactioned: string
  company: {
    thumbnail: string | null
    company_name: string
    id: number
  }
  buyer?: PortfolioTransactionStakeholder
  seller?: PortfolioTransactionStakeholder
  company_name: string
  id: number
  price_currency?: Currency
}

export interface PortfolioTransactionIndex {
  values: PortfolioTransaction[]
  total_count: number
}

export interface PortfolioTransactionStakeholder {
  id: number
  first_name: string
  middle_name: string
  last_name: string
  legal_name: string
}

export interface Price {
  sellable_id: number
  sellable_type: string
  sellable_name: string
  price: number
}

export interface ProcessableData {
  transactioned: string
  price: number
  quantity: number
  id: number
  buyer_id: number
  debt_id?: number
  type?: string
  price_currency: Currency
}

export enum ProcessableProcessingStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  CLOSING = 2,
  INVALID = 3,
  ERROR = 4,
  SUCCESS = 5,
}

export interface ProcessableResponse {
  id: number
  company_id: number
  processable_file: string
  processable_file_file_name: string
  processable_output: string
  processable_processing_end: string
  has_online_issuances?: boolean
  can_impact_equity_valuations?: boolean
  type?: string
  processable_processing_status: ProcessableProcessingStatus
  processable_result: ProcessableResult
  statistics?: ProcessableStatistics
  extracted_data?: ExtractedData
}

export interface ProcessableResult {
  is_valid: boolean
  has_info: boolean
  has_warnings: boolean
  has_validation_errors: boolean
  has_exceptions: boolean
  info: string[]
  exceptions: string[]
  warnings: Record<string, string[]>
  validation_errors: Record<string, string[]>
  data?: string | ProcessableResult[]
  metadata?: Record<string, string | boolean | number>
}

export interface ProcessableStatistics {
  num_draft: number
  num_in_progress: number
  num_published: number
}

export interface Psc0809FilingParams {
  type: PscFilingType
  report_options: {
    statement_type: CompanyStatement | PersonStatement | StatementType
    withdrawal_restriction?: WithdrawalRestriction
    relevant_date?: string
    register_entry_date: string
    section_790d?: boolean
    section_790e?: boolean
    title?: string
    individual_first_name?: string
    individual_last_name?: string
    date_of_birth?: string
    rle_name?: string
    orp_name?: string
    restrictions_notice?: boolean
    relevant_psc08_filing?: number
  }
}

export enum PscFilingType {
  PSC01 = 'Reporting::Reports::Gb::Psc01',
  PSC02 = 'Reporting::Reports::Gb::Psc02',
  PSC03 = 'Reporting::Reports::Gb::Psc03',
  PSC04 = 'Reporting::Reports::Gb::Psc04',
  PSC05 = 'Reporting::Reports::Gb::Psc05',
  PSC06 = 'Reporting::Reports::Gb::Psc06',
  PSC07 = 'Reporting::Reports::Gb::Psc07',
  PSC08 = 'Reporting::Reports::Gb::Psc08',
  PSC09 = 'Reporting::Reports::Gb::Psc09',
}

export interface PublishMembersPostParams {
  action_type: ShareRegisterBatchActionType
  share_register_type: ShareRegisterType
  company_id: number
  processable_id: number
  members_to_create_data?: Array<{
    stakeholder_id: number
    date_of_entry: string
  }>
  members_to_cease_data?: Array<{
    stakeholder_id?: number
    date_of_cessation: string
  }>
}

export type PublishShareRegistersPostParams = ShareRegistersBatchParams & {
  action_type: ShareRegisterBatchActionType
  share_register_type: ShareRegisterType
}

export enum RegisteredEntityType {
  COMPANY = 'Actor::Company::Company',
  USER = 'Actor::User::User',
}

export interface RegistersMetadata {
  latest_psc08_filing_data?: {
    status: FlowableFilingStatus
    url: string
    statement_type: CompanyStatement | PersonStatement
  }
  latest_psc09_filing_data?: {
    status: FlowableFilingStatus
    url: string
    statement_ceased_date: string
  }
  published_allotments_count: number
  pending_allotments_count: number
  published_transfers_count: number
  pending_transfers_count: number
  published_share_register_entries_count: number
  pending_share_register_entries_count: number
  member_start_confirmation_required: boolean
  corporate_cosec_count: number
  individual_cosec_count: number
  has_active_company_secretary: boolean
  has_corporate_directors: boolean
  has_individual_directors: boolean
  has_individual_psc: boolean
  has_rle: boolean
  has_orp: boolean
  psc09_filing_later_than_psc08_filing: boolean
  has_psc08_statements: boolean
  has_active_psc08_statements: boolean
  has_active_company_statements: boolean
}

export enum RegistrationClass {
  STANDARD = 0,
  REVOCATION = 1,
}

export enum RegistrationState {
  DRAFT = 0,
  PUBLISHED = 1,
  RETIRED = 2,
}

export enum RegistrationStateCategory {
  ACTIVE = 0,
  INACTIVE = 1,
}

export enum RegistrationStatus {
  DRAFT = 0,
  PUBLISHED = 1,
}

export enum RelationStatus {
  DRAFT = 0,
  PUBLISHED = 1,
}

export interface ReportElement {
  created_at: string
  id: number
  metadata1:
    | (
        | string
        | Record<string, unknown>
      )
    | null
  metadata2:
    | (
        | string
        | Record<string, unknown>
      )
    | null
  metadata_date1: string | null
  metadata_datetime1: string | null
  report_id: number
  updated_at: string
  data: Record<string, unknown> | null
}

export enum ReportType {
  OPTION_ONLINE_GRANT_ISSUANCES = 'OPTION_ONLINE_GRANT_ISSUANCES',
  PHANTOM_SHARE_ONLINE_GRANT_ISSUANCES = 'PHANTOM_SHARE_ONLINE_GRANT_ISSUANCES',
  RSU_ONLINE_GRANT_ISSUANCES = 'RSU_ONLINE_GRANT_ISSUANCES',
  ALL_DATA = 'Reporting::Reports::AllData',
  ALLOTMENTS_OVERVIEW = 'Reporting::Reports::AllotmentsOverview',
  CAP_TABLE = 'Reporting::Reports::CapTable',
  COMPENSATION_BANDS = 'Reporting::Reports::CompensationBands',
  CUSTOM_TRANSACTIONS = 'Reporting::Reports::CustomTransactions',
  DEBT_TRANSACTION_HISTORY = 'Reporting::Reports::DebtTransactionHistory',
  DIRECTORS_REGISTER = 'Reporting::Reports::DirectorsOverview',
  DOWNLOAD_INTERNAL_DOCUMENTS = 'Reporting::Reports::DownloadInternalDocuments',
  DOWNLOAD_PLAN_DOCUMENTS = 'Reporting::Reports::DownloadPlanDocuments',
  DOWNLOAD_RESOLUTION_DOCUMENTS = 'Reporting::Reports::DownloadResolutionDocuments',
  EMPLOYEE_GRANT_REFRESHERS_REPORT = 'Reporting::Reports::EmployeeGrantRefreshersReport',
  EMPLOYEE_SCORECARDS = 'Reporting::Reports::EmployeeScorecards',
  EXIT_MODELLING = 'Reporting::Reports::ExitModeling',
  AP01 = 'Reporting::Reports::Gb::Ap01',
  AP02 = 'Reporting::Reports::Gb::Ap02',
  AP03 = 'Reporting::Reports::Gb::Ap03',
  AP04 = 'Reporting::Reports::Gb::Ap04',
  CH01 = 'Reporting::Reports::Gb::Ch01',
  CH02 = 'Reporting::Reports::Gb::Ch02',
  CH03 = 'Reporting::Reports::Gb::Ch03',
  CH04 = 'Reporting::Reports::Gb::Ch04',
  CS01 = 'Reporting::Reports::Gb::Cs01',
  CSOP_ANNUAL_RETURN = 'Reporting::Reports::Gb::CsopAnnualReturn',
  EIS1 = 'Reporting::Reports::Gb::Eis1',
  EMI_ANNUAL_RETURN = 'Reporting::Reports::Gb::EmiAnnualReturn',
  EMI_NOTIFICATION = 'Reporting::Reports::Gb::EmiNotification',
  OTHER_ERS_ANNUAL_RETURN = 'Reporting::Reports::Gb::OtherErsAnnualReturn',
  PSC01 = 'Reporting::Reports::Gb::Psc01',
  PSC02 = 'Reporting::Reports::Gb::Psc02',
  PSC03 = 'Reporting::Reports::Gb::Psc03',
  PSC04 = 'Reporting::Reports::Gb::Psc04',
  PSC05 = 'Reporting::Reports::Gb::Psc05',
  PSC06 = 'Reporting::Reports::Gb::Psc06',
  PSC07 = 'Reporting::Reports::Gb::Psc07',
  PSC08 = 'Reporting::Reports::Gb::Psc08',
  PSC09 = 'Reporting::Reports::Gb::Psc09',
  SEIS1 = 'Reporting::Reports::Gb::Seis1',
  SH01 = 'Reporting::Reports::Gb::Sh01',
  SH02 = 'Reporting::Reports::Gb::Sh02',
  SH06 = 'Reporting::Reports::Gb::Sh06',
  TM01 = 'Reporting::Reports::Gb::Tm01',
  TM02 = 'Reporting::Reports::Gb::Tm02',
  VAL231 = 'Reporting::Reports::Gb::Val231',
  IMPORTABLE_DATA = 'Reporting::Reports::ImportableData',
  SH6_REPORT = 'Reporting::Reports::In::OptionSh6Report',
  INCENTIVE_POOL = 'Reporting::Reports::IncentivePoolHistory',
  MEMBERS_REGISTER = 'Reporting::Reports::MembersRegister',
  ONLINE_GRANT_ISSUANCES = 'Reporting::Reports::OnlineGrantIssuances',
  OPTION_GRANT_OVERVIEW = 'Reporting::Reports::OptionGrantOverview',
  OPTION_TRANSACTION_HISTORY = 'Reporting::Reports::OptionTransactionHistory',
  OPTION_VESTING_OVERVIEW = 'Reporting::Reports::OptionVestingOverview',
  PENDING_TRANSACTIONS_OVERVIEW = 'Reporting::Reports::PendingTransactionsOverview',
  PHANTOM_SHARE_GRANT_OVERVIEW = 'Reporting::Reports::PhantomShareGrantOverview',
  PHANTOM_SHARE_TRANSACTION_HISTORY = 'Reporting::Reports::PhantomShareTransactionHistory',
  PHANTOM_SHARE_VESTING_OVERVIEW = 'Reporting::Reports::PhantomShareVestingOverview',
  PSCS_OVERVIEW = 'Reporting::Reports::PscsOverview',
  ROUND_MODELLING = 'Reporting::Reports::RoundModeling',
  RSU_GRANT_OVERVIEW = 'Reporting::Reports::RsuGrantOverview',
  RSU_TRANSACTION_HISTORY = 'Reporting::Reports::RsuTransactionHistory',
  RSU_VESTING_OVERVIEW = 'Reporting::Reports::RsuVestingOverview',
  SECRETARIES_OVERVIEW = 'Reporting::Reports::SecretariesOverview',
  SHARE_BASED_PAYMENTS = 'Reporting::Reports::ShareBasedPayments',
  SHARE_GRANT_OVERVIEW = 'Reporting::Reports::ShareGrantOverview',
  SHARE_GRANT_TRANSACTION_HISTORY = 'Reporting::Reports::ShareGrantTransactionHistory',
  SHARE_REGISTER = 'Reporting::Reports::ShareRegister',
  SHARE_VESTING_OVERVIEW = 'Reporting::Reports::ShareVestingOverview',
  SHAREHOLDER_OVERVIEW = 'Reporting::Reports::ShareholderOverview',
  SHAREHOLDER_REGISTER = 'Reporting::Reports::ShareholderRegister',
  STAKEHOLDER_TRANSACTIONS = 'Reporting::Reports::StakeholderTransactions',
  TRANSACTION_HISTORY = 'Reporting::Reports::TransactionHistory',
  TRANSFERS_OVERVIEW = 'Reporting::Reports::TransfersOverview',
  VALUATION_APPENDIX = 'Reporting::Reports::ValuationAppendix',
  VALUATION_REQUEST_DATA_COLLECTION = 'Reporting::Reports::ValuationRequestDataCollection',
  VALUATION_REQUEST_DATA_PACKET = 'Reporting::Reports::ValuationRequestDataPacket',
  WARRANT_GRANT_OVERVIEW = 'Reporting::Reports::WarrantGrantOverview',
  WARRANT_TRANSACTION_HISTORY = 'Reporting::Reports::WarrantTransactionHistory',
  WARRANT_VESTING_OVERVIEW = 'Reporting::Reports::WarrantVestingOverview',
  SHARE_ONLINE_GRANT_ISSUANCES = 'SHARE_ONLINE_GRANT_ISSUANCES',
  WARRANT_ONLINE_GRANT_ISSUANCES = 'WARRANT_ONLINE_GRANT_ISSUANCES',
}

export enum RequestExecutionType {
  TRANSFER = 1,
  CASHLESS_EXERCISE = 2,
  EXERCISE_FROM_PROFITS = 3,
  BUYBACK_CANCELLATION = 4,
}

export interface RequestTwoFactorEnablementPostParams {
  method: TwoFactorMethod
  dial_code?: string | null
  phone_number?: string | null
}

export interface RequestTwoFactorEnablementResponse {
  id: number
  authenticator_qrcode_uri: string
  authenticator_secret_key: string
}

export interface RequestTwoFactorVerificationPostParams {
  method: TwoFactorMethod
}

export interface RequestTwoFactorVerificationResponse {
  id: number
}

export interface Resolution {
  id: number
  type: string
  name: string
  date_adopted: string
  documents_count: number
  company_id: number
  created_at: string
  updated_at: string
  resolution_document?: Document
  associated_documents?: Document[]
  search_highlight?: SearchHighlight
}

export enum ResolutionBatchActionType {
  CREATE = 0,
}

export interface ResolutionParams {
  name: string
  date_adopted: string
  blob_id: number
  resolution_category: BoardResolutionCategory | ShareholderResolutionCategory
}

export enum RestrictionCategory {
  FORFEITURE = 0,
  TRANSFER = 1,
  DIVIDENDS = 2,
  VOTING = 3,
  OTHER = 999,
}

export interface ReviewMember {
  stakeholder_id: number
  legal_name: string
  membership_start_at: string
  membership_start_imprecise: boolean
  membership_end_at: string
  membership_end_imprecise: boolean
  balance: string
  total_acquired: string
  total_disposed: string
  share_classes: ReviewShareClass[]
}

export interface ReviewShareClass {
  name: string
  transactions: ReviewShareClassTransaction[]
}

export interface ReviewShareClassTransaction {
  type_name: string
  transactioned: string
  acquired?: string
  disposed?: string
  price: string
  cost: string
  note?: string
}

export interface RsuStatistics {
  counts: {
    total: number
    online_count: number
    employment_related_count: number
    grant_count: IdValueSet
  }
  quantity: {
    authorized_outstanding: number
    exercised: number
    issued_exercised: number
    issued_outstanding: number
    outstanding: number
    unauthorized_outstanding: number
    total: number
    share_class: NameValueSet
  }
  votes: {
    outstanding?: number
    exercised: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  transaction_quantity: {
    share_class: NameValueSet
  }
}

export interface SalesAllowanceAttributes {
  allowed_fraction: number
  share_class_ids?: number[]
  security_plan_ids?: number[]
}

export interface SearchHighlight {
  name?: string
  content?: string
}

export interface SecretaryDetailsAttributes {
  individual_first_name?: string
  individual_last_name?: string
  individual_title?: string
  building_name?: string
  street?: string
  post_town?: string
  county?: string
  postcode?: string
  country?: string
  residential_building_name?: string
  corporate_governing_law?: string
  corporate_legal_form?: string
  corporate_name?: string
  corporate_registered?: string
  corporate_registration_number?: string
  individual_former_names?: Array<{
    first_name?: string
    last_name?: string
  }>
}

export type SecretaryFilingParams = CommonFilingParams & {
  filing_type?: SecretaryFilingType
}

export interface SecretaryFilingPreview {
  preview_url: string
}

export enum SecretaryFilingType {
  AP03 = 'Reporting::Reports::Gb::Ap03',
  AP04 = 'Reporting::Reports::Gb::Ap04',
  CH03 = 'Reporting::Reports::Gb::Ch03',
  CH04 = 'Reporting::Reports::Gb::Ch04',
  TM02 = 'Reporting::Reports::Gb::Tm02',
}

export interface SecretaryPostParams {
  details_attributes?: SecretaryDetailsAttributes
  filing_type?: SecretaryFilingType
  status?: number
  appointed_at?: string
  terminated_at?: string
  consent_to_act?: boolean
}

export interface SecretaryPreviewTerminateParams {
  filing_type: SecretaryFilingType
  id: number
  date_of_changes: string
  date_of_termination: string
}

export interface SecretaryPutParams {
  details_attributes?: SecretaryDetailsAttributes
  filing_type?: SecretaryFilingType
  id?: number
  changed_at?: string
  terminated_at?: string
}

export interface SecurityDebtInterestAccrual {
  id: number
  quantity: string
  quantity_balance?: string
  transactioned: string
  translated_type_simplified: string
  type: string
}

export interface SecurityGrant {
  allow_revoke: boolean
  any_draft_transactions: boolean
  any_online_executed_transactions: boolean
  board_approval_date: string | null
  can_be_revoked_and_published?: boolean
  cancelled: string | number
  cash_settlement_payout_calculation: CashSettlementPayoutCalculation | null
  cash_settlement_payout_factor: string | null
  cash_settlement_payout_type: CashSettlementPayoutType | null
  company_country: string
  company_email: string
  company_id: number
  company_name: string
  company_terminology_settings: TerminologySettings
  company_thumbnail: string
  config_enable_conversion_window_at_grant_date: boolean
  consideration_payment_date: string | null
  consideration_price: string
  consideration_price_currency: Currency
  consideration_price_in_user_default_currency: string
  consideration_price_rate: string | null
  conversion_document_set_id: number | null
  conversion_note: string
  conversion_price?: string | number
  conversion_price_currency?: Currency
  conversion_price_in_user_default_currency?: string
  conversion_price_rate?: string | null
  conversion_window_end: string | null
  conversion_window_start: string | null
  converted: string | number
  convertible?: string
  created_at: string
  csop_value: string | null
  current_status: GrantStatus
  current_transaction_published: boolean
  document_set_id: number | null
  documents?: Document[]
  effective_estimated_total_value: string
  effective_estimated_vested_value: string
  effective_quantity?: string
  emi_value: string | null
  employment_related: boolean
  execution_type: ExecutionType
  expired: string | number
  expires: string
  expires_adjustment_type?: ExpiresAdjustmentType
  filtered_grant_transactions_draft_count: number
  flows?: Flow[]
  fully_loaded: boolean
  funding_round_id: number | null
  grant_reason: GrantReason | null
  grant_transactions_draft_count: number
  grant_transactions_in_progress_count: number
  grant_transactions_publish_count: number
  grant_transactions_revoked_count: number
  granted: string
  grantholder?: LightStakeholder | ShowStakeholder
  grantholder_id: number
  grantor_differ_from_company: boolean
  has_adjustments: boolean
  has_been_terminated: boolean
  has_fixed_grant_date: boolean
  has_non_service_condition: boolean
  has_open_conversion_window: boolean
  hurdle_price?: string
  hurdle_price_currency?: Currency
  hurdle_price_in_user_default_currency?: string
  hurdle_price_rate?: string | null
  id: number
  is_company_active: boolean
  is_conversion_window_set: boolean
  is_converting: boolean
  is_flow_in_progress: boolean
  is_hurdle_valuation?: boolean
  is_issuing: boolean
  is_market_condition: boolean
  is_notified: boolean
  is_shareholder_register_enabled?: boolean
  is_terminating: boolean
  issuance_order_execution_id: number | null
  issuance_transaction_id: number
  latest_public_value_in_user_currency: Currency
  non_service_condition: string | null
  note: string | null
  notified: string | null
  other_conditions: string | null
  priority_key: number | null
  outstanding: string | number
  price?: string | number
  published: string | null
  quantity: string
  registered?: string
  revoked: boolean
  security_plan_id: number
  security_restrictions?: SecurityRestriction[]
  equity_value: number | null
  number_of_securities: number | null
  equity_as_percentage_of_fully_diluted: number | null
  share_class_nominal_value_currency: Currency
  termination_retain_vested_quantity: boolean
  termination_vested_quantity: number | null
  transferred_from_id: number | null
  translated_acceptance_status: string
  type: string
  unvested_quantity: string | number
  updated_at: string
  vested_quantity: string | number
  vesting_schedule: VestingSchedule
  vesting_start: string
  vesting_type: VestingType
  grant_prices: Array<{
    grant_price: string
    transactioned: string
  }>
  security_plan: {
    enable_authorizations: boolean
    enable_shared_authorizations: boolean
    has_corporate_conversion_set: boolean
    has_individual_conversion_set: boolean
    id: number
    jurisdiction: string
    name: string
    requires_approval: boolean
    security_plan_type?: OptionPlanType | null
    share_class_id: number
    share_class_name: string
    type: string
  }
  soft_and_hard_linked_valuations?: Array<{
    expiration: string | null
    is_soft_link: boolean
    price: string | null
    price_currency: Currency | null
    type: ValuationType
    valid_for: number | null
    valuated: string
  }>
  valuations: Array<{
    id: number
    price: string
    price_currency: Currency
    type: string
    valuated: string
  }>
}

export interface SecurityGrantBreakdown {
  id: number
  name: string
  total_quantity: string | number
  type: string
  unvested_percentage: (string | number) | null
  unvested_quantity: string | number
  vested_percentage: (string | number) | null
  vested_quantity: string | number
  security_plan: {
    id: number
    name: string
    termination_cancellation_rule: TerminationCancellationRule | null
    termination_conversion_note: string | null
    termination_enable_conversion_window: boolean | null
    termination_retain_vested_quantity: boolean | null
    type: string
    conversion_document_sets: Array<{
      id: number
      name: string
      type: string
    }>
    termination_rules: Array<{
      id: number
      name: string
      period_count: number
      period_type: PlanPeriodType
    }>
  }
}

export interface SecurityGrantTemplate {
  cash_settlement_payout_factor: number | null
  cash_settlement_payout_calculation: CashSettlementPayoutCalculation | null
  cash_settlement_payout_type: CashSettlementPayoutType | null
  valuation_id?: number
  config_enable_conversion_window_at_grant_date: boolean
  company_id: number
  employment_related: boolean
  name: string
  other_conditions: string | null
  cliff_percentage: string | null
  expires_unit: ExpiresUnit | null
  expires: number | null
  id: number
  type: SecurityGrantTemplateType
  vesting_cliff: number | null
  vesting_interval: number | null
  vesting_months: number | null
  vesting_on: VestingOn | null
  vesting_type: VestingType
  vesting_description_custom: string | null
  non_linear_periods?: Array<{
    interval: number
    percentage: number
    span: number
  }>
}

export enum SecurityGrantTemplateType {
  OPTION = 'Security::Option::GrantTemplate',
  PHANTOM_SHARE = 'Security::PhantomShare::GrantTemplate',
  RSU = 'Security::Rsu::GrantTemplate',
  SHARE = 'Security::Share::GrantTemplate',
  WARRANT = 'Security::Warrant::GrantTemplate',
}

export interface SecurityPlan {
  approved?: string
  authority_reference?: string
  authorization_type?: PlanAuthorizationType
  authorized?: number
  available?: number
  board_resolution?: LightResolution
  company_id: number
  conditions?: string
  convert_to_share_class_id?: number
  converted?: number
  created_at?: string
  creator_id: number
  created_by: string
  currency: Currency
  current_value: number
  document_categories: number[]
  documents?: Document[]
  enable_authorizations: boolean
  enable_shared_authorizations: boolean
  has_corporate_conversion_set: boolean
  has_individual_conversion_set: boolean
  has_online_transactions_in_progress: boolean
  has_published_transactions: boolean
  id: number
  incentive_pool_id?: number
  individual_conversion_document_set?: IndividualConversionDocumentSet
  individual_issuance_document_set?: IndividualIssuanceDocumentSet
  is_active: boolean
  jurisdiction: string
  name: string
  note?: string
  outstanding?: number
  requires_approval: boolean
  security_grant_template?: SecurityGrantTemplate
  security_plan_type?: OptionPlanType
  security_plans?: LightSecurityPlan[]
  share_class_currency?: Currency
  share_class_id: number
  share_class_name: string
  share_issuance_stage?: ShareIssuanceStage
  shared_pool_authorizations?: LightPoolAuthorization[]
  shareholder?: LightStakeholder
  shareholder_id?: number
  shareholder_resolution?: LightResolution
  stakeholder_creator_id: number
  stakeholder_updater_id: number
  termination_cancellation_rule?: TerminationCancellationRule
  termination_conversion_note?: string
  termination_enable_conversion_window?: boolean
  termination_retain_vested_quantity?: boolean
  termination_rules?: TerminationRule[]
  terms_and_conditions?: string
  transferee_id?: number
  type: string
  updated_at?: string
  updater_id: number
  updated_by: string
  vested?: number
  execution_type: ExecutionType
  status: PlanStatus | null
  adopted: string | null
  published: string | null
}

export interface SecurityPlanCount {
  id: string
  value: number
  document_sets: Array<{
    id: string
    value: number
  }>
  security_plan_type?: Array<{
    value: number | null
    id: OptionPlanType | null
  }>
}

export interface SecurityPlanStatistics {
  counts: {
    option: SecurityPlanCount
    warrant: SecurityPlanCount
    share_grant: SecurityPlanCount
    phantom_share: SecurityPlanCount
    rsu: SecurityPlanCount
    plans_requiring_approval_count?: number
  }
}

export interface SecurityRestriction {
  category: RestrictionCategory
  description: string
  end_date: string | null
  id: number
  start_date: string
}

export interface SecurityTransaction {
  accelerates_vesting?: boolean | null
  accrual_method?: AccrualMethod
  accrual_start_date?: string | null
  adjustment_for_non_uk_residence?: boolean | null
  basic_modifications_allowed?: boolean
  buyer?: LightStakeholder | ShowStakeholder
  buyer_administrative_expenses?: string | null
  buyer_administrative_expenses_currency?: Currency | null
  buyer_id?: number | null
  buyer_share_class_id?: number
  cancellation_reason: DebtCancellationReason | null
  company_id: number
  company_name?: string
  compensation?: (string | number) | null
  consideration_payment_date?: string | null
  conversion_price?: string | null
  conversion_price_currency?: Currency
  conversion_price_discount?: string | null
  conversion_price_rate?: number | null
  cost?: string | number
  created_at?: string
  creator?: string
  csop_value?: string | null
  day_count_type?: DayCountType | null
  debt_id?: number | null
  debt_transaction_type?: DebtTransactionType
  debt_type?: DebtType
  documents?: Document[] | null
  dotas_reference_number?: string | null
  eis_termination_date?: string | null
  eis_value_received_from_company?: number
  emi_value?: string | null
  employment_related?: boolean | null
  executed_online?: boolean
  execution_type: ExecutionType
  exercise_cost?: string
  expires?: string | null
  external_certificate_id?: string | null
  external_transaction_id: string | null
  funding_round_id: number | null
  funding_round_name?: string | null
  has_been_filed?: boolean
  hurdle_price?: string
  hurdle_price_currency?: Currency
  hurdle_price_rate?: string | null
  id: number
  interest_compounding_period?: CompoundingPeriod | null
  interest_rate?: string | null
  is_amendment?: boolean | null
  is_buyback?: boolean | null
  is_cancellation: boolean
  is_company_transaction?: boolean
  is_compound_interest?: boolean | null
  is_conversion?: boolean
  is_conversion_price_fixed?: boolean
  is_eis?: boolean | null
  is_filing_required?: boolean
  is_flow_in_progress?: boolean
  is_group_amendment_transaction: boolean | null
  is_group_issuance_transaction: boolean | null
  is_group_transfer: boolean
  is_hurdle_valuation?: boolean
  is_one_time_fixed_interest?: boolean | null
  is_registered?: boolean | null
  is_secured?: boolean
  is_seis?: boolean | null
  is_share_class_conversion?: boolean
  is_taxable?: boolean
  is_transfer_or_grant_transfer?: boolean | null
  matures?: string | null
  offline_payment_date?: string | null
  price: string
  price_currency: Currency
  price_rate: string | null
  priority_key: number | null
  public_note?: string | null
  published: string | null
  qualifying_financing?: string | null
  qualifying_financing_currency?: Currency | null
  qualifying_financing_rate?: number | null
  quantity: string
  quantity_balance?: string | null
  quantity_status?: (DebtQuantityStatus | GrantQuantityStatus) | null
  registered?: string | null
  registration_class: RegistrationClass
  registration_state: RegistrationState
  registration_state_category: RegistrationStateCategory
  registration_status: RegistrationStatus
  retention_taxable?: string | null
  retention_taxable_currency?: string | null
  retired: string | null
  revocation_note?: string | null
  round_valuation?: string | null
  round_valuation_currency?: Currency | null
  security_grant?: SecurityGrant
  security_grant_id: number | null
  security_restrictions?: SecurityRestriction[]
  seis_termination_date?: string | null
  seis_value_received_from_company?: number
  seller?: LightStakeholder | ShowStakeholder
  seller_id?: number | null
  seller_share_class_id?: number
  seller_share_class_name?: string
  share_adjustment_id?: number | null
  share_class_id?: number
  share_class_name?: string
  share_class_nominal_value?: string
  share_class_nominal_value_currency?: Currency
  share_cost?: string | null
  share_numbers?: string | null
  share_price?: string | null
  share_price_currency?: Currency | null
  share_quantity?: string | null
  share_register_entry?: ShowShareRegisterEntryDetails
  share_registered?: string | null
  share_transaction_type?: ShareTransactionType
  shares_sold_status?: SharesSoldStatus | null
  transaction_origin: TransactionOrigin
  transaction_set_id?: number | null
  transaction_set_name?: string | null
  transaction_set_url?: string | null
  transaction_type?: TransactionType
  transactioned: string
  translated_acceptance_status?: string
  translated_type: string
  translated_type_simplified: string
  type?: string
  updated_at: string
  updater?: string
  use_manual_share_inputs?: boolean
  valuation_cap?: string | null
  valuation_cap_currency?: Currency | null
  valuation_cap_rate?: number | null
  vesting_schedule?: VestingSchedule
  votes?: string
  converted_from?: {
    debt_type?: DebtType
    id: number
    type: string
    url?: string
  }
  company?: {
    company_name: string
    country: string
    email: string
    id: number
    thumbnail: string
  }
  seller_share_class?: {
    id: number
    name: string
    nominal_value: string
    nominal_value_currency: Currency
  }
  share_class?: {
    id: number
    name: string
    nominal_value: string
    nominal_value_currency: Currency
  }
}

export interface SecurityTransactionIndex {
  total_count?: number
  values: Array<SecurityTransaction | SecurityDebtInterestAccrual>
}

export interface SEIS1ReportElement {
  created_at: string
  id: number
  metadata1:
    | (
        | string
        | Record<string, unknown>
      )
    | null
  metadata2:
    | (
        | string
        | Record<string, unknown>
      )
    | null
  metadata_date1: string | null
  metadata_datetime1: string | null
  report_id: number
  updated_at: string
  data: {
    address: string
    address_excluding_postcode: string
    exchange_rate?: string
    legal_name: string
    original_amount?: string
    original_currency?: string
    postcode: string
    total_amount: string
    total_quantity: string
    tx_ids: number[]
  }
}

export interface SEISInvestmentDetails {
  amount: number
  original_amount: number
  original_currency: Currency
  exchange_rate: number
}

export interface SellableAmount {
  share_class_id?: number
  security_plan_id?: number
  amount?: number
  name?: string
}

export interface SellerAttributes {
  stakeholder_id: number
  sales_allowances_attributes: SalesAllowanceAttributes[]
}

export enum SettlementBufferDays {
  WITHOUT_FILING = 11,
  WITH_FILING = 60,
}

export interface ShareAdjustment {
  id: number
  is_adjusting_pool: boolean
  pool_authorization_count: number
  security_transaction_count: number
  share_class_id: number
  share_class_name: string
  to_nominal_value: string
  to_ratio: number
  registration_class: RegistrationClass
  registration_state: RegistrationState
  registration_state_category: RegistrationStateCategory
  registration_status: RegistrationStatus
  currency?: Currency | null
  from_nominal_value?: string | null
  from_ratio?: number | null
  funding_round_id?: number | null
  funding_round_name?: string | null
  note?: string | null
  priority_key?: number | null
  published?: string
  transactioned?: string
  retired?: boolean | null
  documents?: Document[] | null
  processable?: ProcessableResponse
  adjustment_type: AdjustmentType
}

export interface ShareAdjustmentPostParams {
  documents_attributes?: DocumentAttributes[]
  from_ratio: number
  to_ratio: number
  transactioned: string
  is_adjusting_pool: boolean
  publish_registration: boolean
  share_class_id: number
  funding_round_id?: number
  priority_key?: number | null
  note?: string | null
}

export interface ShareAdjustmentPutParams {
  documents_attributes?: DocumentAttributes[]
  from_ratio?: number
  to_ratio?: number
  transactioned?: string
  is_adjusting_pool?: boolean
  publish_registration?: boolean
  from_nominal_value?: number
  revoke_registration?: boolean
  priority_key?: number | null
  note?: string | null
  revocation_note?: string | null
}

export interface ShareCertificate {
  id: number
  certificate_number: number
  share_class_name: string
  signatureless: boolean
  accepted: boolean
  is_watermarked: boolean
  quantity: string
  status: ShareCertificateStatus
  documents?: Document[]
  flows: Flow[]
  buyer?: ShowStakeholder
  notes: string | null
  cancelled?: string
  accepted_at?: string
}

export enum ShareCertificateBatchActionType {
  SEND_FOR_SIGNING = 0,
}

export enum ShareCertificateStatus {
  OFFLINE = -1,
  DRAFT = 0,
  REGISTERED = 1,
  SUPERSEDED = 2,
  IN_SIGNING = 1000,
  SIGNED = 1001,
  CANCELLED = 1002,
}

export interface ShareClassBulkUpdateRights {
  id: number
  rights: string
}

export interface ShareClassBulkUpdateRightsParams {
  company_id: number
  share_classes: ShareClassBulkUpdateRights[]
}

export interface ShareClassSummary {
  id: number
  name: string
  nominal_value: string
  total_acquired: string
  total_disposed: string
  balance: string
  nominal_value_currency: Currency
}

export interface ShareGrantStatistics {
  quantity: {
    authorized_outstanding: number
    exercised: number
    issued_exercised: number
    issued_outstanding: number
    total: number
    unauthorized_outstanding: number
    share_class: NameValueSet
  }
  counts: {
    total: number
    online_count: number
    employment_related_count: number
    grant_count: IdValueSet
  }
  votes: {
    outstanding?: number
    exercised: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  transaction_quantity: {
    share_class: NameValueSet
  }
}

export type ShareholderResolution = Resolution & {
  resolution_category: ShareholderResolutionCategory
}

export enum ShareholderResolutionCategory {
  ORDINARY = 0,
  MINUTES = 1,
  OTHER = 2,
  SPECIAL = 3,
  WRITTEN = 4,
  INVESTOR_MAJORITY_CONSENT = 5,
  INVESTOR_DIRECTOR_CONSENT = 6,
}

export interface ShareholderResolutions {
  values: ShareholderResolution[]
  total_count: number
}

export interface Shareholding {
  share_class_id?: number
  sum?: number
}

export enum ShareIssuanceStage {
  PLAN = 0,
  GRANT = 1,
  CONVERSION = 2,
  NEVER = 3,
}

export enum ShareRegisterBatchActionType {
  PUBLISH_ENTRIES = 2,
  PUBLISH_MEMBERS = 3,
  PREPARE_ENTRIES_REVIEW = 4,
  PREPARE_MEMBERS_REVIEW = 5,
  CONFIRM_REGISTER_SETUP = 6,
  PREPARE_OFFICERS_AND_PSCS_REVIEW = 7,
  GENERATE_SHARE_CERTIFICATES = 8,
  SIGN_SHARE_CERTIFICATES = 9,
}

export interface ShareRegisterEntries {
  values: ShareRegisterEntry[]
  total_count: number
}

export enum ShareRegisterEntriesProcessableProcessingStatus {
  DISCARDED = 10,
}

export interface ShareRegisterEntry {
  status: ShareRegisterStatus
  filing_status?: AllotmentFilingStatus
  type: ShareRegisterType
  share_class?: {
    id?: number
    name?: string
  }
  transaction_security_grant?: {
    id: number
    type: string
  }
  id: number
  company_id: number
  quantity: string
  price: string
  transactioned: string
  cost: string
  is_pure_share_transaction: boolean
  is_transaction_draft: boolean
  created_at: string
  updated_at: string
  created_by: string
  updated_by: string
  nominal_value: string
  type_name: string
  eligible_for_direct_filing: boolean
  security_transaction_id?: number
  debt_id?: number
  buyer_legal_name?: string
  buyer_email?: string
  seller_legal_name?: string
  seller_email?: string
  filing_generated_at?: string
  filing_report_url?: string
  filed?: string
  share_adjustment_id?: number
  adjustment_type?: string
  adjustment_ratio?: string
  balance?: Record<string, unknown>
  note?: string
  published_at?: string
  price_currency: Currency
  nominal_value_currency?: Currency
}

export interface ShareRegisterEntryPutParams {
  note: string
}

export interface ShareRegistersBatchParams {
  status?: ShareRegisterStatus
  filing_status?: AllotmentFilingStatus[]
  share_class_id?: number[]
  included_share_register_ids?: number[]
  excluded_share_register_ids?: number[]
  company_id: number | null
  from_date?: string | null
  to_date?: string | null
  name_or_bkey?: string | null
}

export type ShareRegistersPostParams = PublishShareRegistersPostParams | PublishMembersPostParams

export enum ShareRegisterStatus {
  PENDING = 0,
  PUBLISHED = 1,
}

export enum ShareRegisterType {
  ADJUSTMENT = 'Security::Register::Share::Adjustment',
  ALLOTMENT = 'Security::Register::Share::Allotment',
  CANCELLATION = 'Security::Register::Share::Cancellation',
  CONVERSION = 'Security::Register::Share::Conversion',
  SHARE = 'Security::Register::Share::Share',
  TRANSFER = 'Security::Register::Share::Transfer',
}

export enum SharesSoldStatus {
  SALES_INSTRUCTED = 0,
  SOLD = 1,
}

export interface ShareStatistics {
  capital: {
    share_class: NameValueSet
    total: number
  }
  share_classes: {
    info: Array<{
      id: number
      name: string
    }>
    stakeholder_category: Array<{
      value: number[]
      id: number
      name: string
    }>
    country: Array<{
      value: number[]
      id: number
      name: string
    }>
  }
  votes: {
    deferred?: NameValueSet
    share_class?: NameValueSet
    treasury_share_class?: NameValueSet
    stakeholder_category: NameValueSet
    country: NameValueSet
    total: number
    total_incl_deferred: number
    treasury: number
  }
  quantity: {
    country: NameValueSet
    share_class: NameValueSet
    funding_round: StatisticsByFundingRound
    issued_share_class: NameValueSet
    issued_adjusted: NameValueSet
    deferred: NameValueSet
    treasury_share_class: NameValueSet
    stakeholder_category: Array<{
      by_share_class: NameValueSet
      id: number
      name: string
      value: number
      share: number
    }>
    treasury: number
    total: number
    total_incl_deferred: number
    transaction_type: {
      id: number
      name: string
      value: number
    }
  }
  cost: {
    transaction_type: StatisticsByTransactionType
    funding_round: StatisticsByFundingRound
    issued_share_class?: NameValueSet
    issued_outside_funding_round: number
    total: number
  }
  counts: {
    employment_related_count: number
    total: number
    share_transaction_type: IdValueSet
  }
}

export type ShareTransaction = CommonShareTransaction & {
  adjustment_for_non_uk_residence: boolean
  buyer_share_class_id: number
  created_at: string
  employment_related: boolean
  share_class_id: number
  translated_acceptance_status: string
  type: string
  votes: number
  executed_online: boolean
  creator: string
  updater: string
  share_class_name: string
  dotas_reference_number?: string
  eis_termination_date?: string
  eis_value_received_from_company?: number
  external_certificate_id?: string
  compensation?: number
  hurdle_price?: number
  hurdle_price_rate?: number
  is_hurdle_valuation?: boolean
  quantity_status?: number
  revocation_note?: string
  retention_taxable?: string
  seis_termination_date?: string
  seis_value_received_from_company?: number
  seller_share_class_id?: number
  share_class_nominal_value?: string
  seller_share_class_name?: string
  price_currency?: Currency
  conversion_price_currency?: Currency
  converted_from?: ShowConvertedFrom
  share_register_entry?: ShowShareRegisterEntryDetails
  share_transaction_type: ShareTransactionType
  company: TransactionCompany
  documents?: Document[]
  active_certificate?: {
    certificate_trail: Array<{
      id: number
      certificate_number: number
      status: ShareCertificateStatus
      notes: string
      accepted: boolean
    }>
    documents: Document[]
  }
}

export interface ShareTransactions {
  values: IndexShareTransaction[]
  total_count: number
}

export enum ShareTransactionType {
  ISSUANCE = 0,
  TRANSFER = 1,
  CANCELLATION = 2,
  CONVERSION = 3,
  EXERCISE = 5,
  RSU_CONVERSION = 6,
  TREASURY = 7,
  DEBT_CONVERSION = 9,
  ADJUSTMENT = 10,
  AMENDMENT = 11,
}

export type ShowAdministrator = LightAdministrator & {
  controlled_attributes?: string[]
}

export type ShowCompany = IndexCompany & {
  creator_name_and_email?: string
  csop_enable?: boolean
  has_bank_account?: boolean
  billing_customer_id?: number
  has_published_transactions?: boolean
  has_published_transactions_without_share_numbers?: boolean
  portfolio_transactions_enabled?: boolean
  has_gb_security_plans?: boolean
  billing_email?: string
  subscription_date?: string
  subscription_start_date?: string
  subscription_assisted_onboarding?: boolean
  subscription_comment?: string
  subscription_discount?: number
  subscription_price?: number
  subscription_tax_percentage?: number
  subscription_assisted_onboarding_price?: number
  subscription_stakeholder_limit?: number
  subscription_trial_end_date?: string
  subscription_contract_length?: number
  subscription_renewal_date?: string
  subscription_customized_start_date?: boolean
  subscription_contract_length_in_months?: number
  show_compliance_centre: boolean
  show_emi_share_plan_delivery: boolean
  psc_candidate_count: number
  ready_to_go_live: boolean
  going_live: boolean
  current_user_administrator_id?: number
  plan_upgrade_requested_at?: string
  stakeholder_limit?: number
  hr_integration_limit_reached?: boolean
  ch_identity_verification_enabled?: boolean
  has_unverified_directors?: boolean
  has_unverified_pscs?: boolean
  subscription_price_currency?: Currency
  registers_metadata: RegistersMetadata
  available_reports: ReportType[]
  compensation_configurations?: CompensationConfiguration[]
  config_onboarding_type: OnboardingType
  subscription_period_type?: SubscriptionPeriodType
  subscription_pricing_package?: SubscriptionPricingPackage
  enabled_features?: CompanyFeature[]
  verification_status?: VerificationStatus
  actor_verification?: ActorVerification
  hr_integration_connections: HrIntegrationConnection[]
  stakeholder_type?: StakeholderType
  implementation_manager?: ImplementationManager
  personalised_stakeholders: {
    total: number
    grantholders: number
    investors: number
  }
  signature_service?: SignatureService
}

export interface ShowConvertedFrom {
  id: number
  type: string
  url: string
}

export type ShowInvestor = ShowStakeholder & {
  current_shareholdings?: Shareholding[]
}

export type ShowOptionholder = ShowStakeholder & {
  share_scheme_values?: {
    emi_and_csop_outstanding?: number
    emi_and_csop_granted?: number
    csop_outstanding?: number
    emi_granted?: number
    emi_outstanding?: number
  }
  has_emi_grants?: boolean
  has_csop_grants?: boolean
  has_umv_valuations?: boolean
}

export type ShowShareCertificate = ShareCertificate & {
  company_config_watermark_share_certificates: boolean
  created_at: string
  updated_at: string
  creator: string
  updater: string
  company: {
    id: number
    company_name: string
    thumbnail?: string
    cosec_activation_v3_enabled: boolean
  }
  certificate_trail: Array<{
    id: number
    certificate_number: number
    status: ShareCertificateStatus
    notes: string
    accepted: boolean
  }>
}

export type ShowShareRegisterEntryDetails = IndexShareRegisterEntryDetails & {
  filing?: {
    created_at?: string
    filed?: string
    report?: string
  }
}

export type ShowStakeholder = LightStakeholder & {
  company_accesses: CompanyAccess[]
  about?: string | null
  allow_emails: boolean
  contact_email?: string
  controlled_attributes: string[]
  documents?: Document[] | null
  hr_integration_controlled_attributes?: string[]
  is_verified: boolean | null
  mail_trackings?: MailTracking[]
  registered_entity_capdesk_admin_url?: string
  registered_entity_name?: string
  security_grants_breakdown?: SecurityGrantBreakdown[]
  show_employee_data?: boolean
  show_investor_data?: boolean
  valid_claim_token?: string
}

export enum SignableStakeholderRole {
  SYSTEM = -1,
  ISSUER = 0,
  ISSUER_SIGNATORY_1 = 1,
  ISSUER_WITNESS = 2,
  ISSUER_SIGNATORY_2 = 3,
  ISSUER_SIGNATORY_3 = 4,
  STAKEHOLDER = 100,
  STAKEHOLDER_SIGNATORY_1 = 101,
  STAKEHOLDER_WITNESS = 102,
  STAKEHOLDER_SIGNATORY_2 = 103,
  STAKEHOLDER_SIGNATORY_3 = 104,
}

export interface Signature {
  id: number
  is_last_active_for_party: boolean
  is_on_behalf: boolean
  no_signed_signatures_on_signable: boolean
  on_behalf_of_id: number | null
  on_behalf_of_type: string | null
  service_status: SignatureServiceStatus
}

export interface SignatureService {
  id: number
  account_id: string
  account_name: string
  is_active: boolean
  impersonated_user_id: string
  impersonated_user_email: string
  impersonated_user_name: string
  service_uri?: string
  created_at?: string
  updated_at?: string
  company_id?: number
  authentication_uri?: string
  user_id?: number
}

export enum SignatureServiceStatus {
  DRAFT = 0,
  OUTSTANDING = 1,
  COMPLETED = 2,
  REJECTED = 3,
  CANCELLED = 4,
  FAILED = 5,
}

export enum SignatureSigneeType {
  ISSUER_ONLY = 0,
  STAKEHOLDER_ONLY = 1,
  ISSUER_AND_STAKEHOLDER = 2,
  NO_SIGNEE = 3,
}

export enum SignatureSigningOrder {
  NO_SIGNING = 0,
  STAKEHOLDER_FIRST = 1,
  ISSUER_FIRST = 2,
}

export enum SignatureStakeholderRole {
  SYSTEM = -1,
  OWNER = 0,
  SIGNATORY_1 = 1,
  WITNESS = 2,
  SIGNATORY_2 = 3,
  SIGNATORY_3 = 4,
}

export interface SmsDispatch {
  created_at: string
  id: number
  status: number
  service_error_message?: string
}

export interface Stakeholderable {
  id: number
  name: string
}

export enum StakeholderCategory {
  ADVISOR = 1,
  EMPLOYEE = 2,
  FOUNDER_EXECUTIVE = 3,
  INDIVIDUAL_INVESTOR = 4,
  INSTITUTIONAL_INVESTOR = 5,
  LEAVER = 6,
  TREASURY = 7,
  TRUST = 8,
  OTHER = 50,
  ADMINISTRATOR = 100,
  ANONYMOUS = 102,
}

export interface StakeholderInCompany {
  id: number
  name?: string
  is_registered?: boolean
  enable_equity_calculator_for_grantholders?: boolean
}

export interface StakeholderRegistersMetadata {
  detail_diff?: DetailDiff
  people_register_entries: Array<{
    id: number
    type: PeopleRegisterEntryType
  }>
  register_details?: PeopleRegisterEntryDetailsAttributes
}

export interface StakeholderStatistics {
  stakeholders?: {
    total: number
    is_registered: number
  }
}

export enum StakeholderType {
  GRANTHOLDER = 'grantholder',
  INVESTOR = 'investor',
}

export interface StakeholderUsageType {
  debt_holder?: UsageType
  option_holder?: UsageType
  phantom_share_holder?: UsageType
  rsu_holder?: UsageType
  share_holder?: UsageType
  warrant_holder?: UsageType
}

export interface StatementData {
  date_of_birth?: string
  name?: string
  title?: string
  statement_type: StatementType
}

export enum StatementStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum StatementType {
  NO_INDIVIDUAL_OR_ENTITY_WITH_SIGNFICANT_CONTROL = 'NO_INDIVIDUAL_OR_ENTITY_WITH_SIGNFICANT_CONTROL',
  PSC_CONTACTED_BUT_NO_RESPONSE = 'PSC_CONTACTED_BUT_NO_RESPONSE',
  PSC_DETAILS_NOT_CONFIRMED = 'PSC_DETAILS_NOT_CONFIRMED',
  PSC_EXISTS_BUT_NOT_IDENTIFIED = 'PSC_EXISTS_BUT_NOT_IDENTIFIED',
  PSC_HAS_FAILED_TO_CONFIRM_CHANGED_DETAILS = 'PSC_HAS_FAILED_TO_CONFIRM_CHANGED_DETAILS',
  RESTRICTIONS_NOTICE_ISSUED_TO_PSC = 'RESTRICTIONS_NOTICE_ISSUED_TO_PSC',
  RESTRICTIONS_NOTICE_WITHDRAWN_BY_COMPANY = 'RESTRICTIONS_NOTICE_WITHDRAWN_BY_COMPANY',
  RESTRICTIONS_NOTICE_WITHDRAWN_BY_COURT_ORDER = 'RESTRICTIONS_NOTICE_WITHDRAWN_BY_COURT_ORDER',
  STEPS_TO_FIND_PSC_NOT_YET_COMPLETED = 'STEPS_TO_FIND_PSC_NOT_YET_COMPLETED',
}

export type Statistics = BaseStatistics & {
  all: StatisticsData
  combined: StatisticsData
  published: StatisticsData
  draft: DraftStatisticsData
}

export type StatisticsByFundingRound = Array<{
  id: number | null
  name: number | null
  value: number | null
}>

export type StatisticsByTransactionType = Array<{
  id: 'CANCELLATION' | 'ISSUANCE' | 'PURCHASE' | 'SALE'
  name: string
  value: number
}>

export enum StatisticsCategory {
  ALL = 0,
  GRANTS = 1,
  SHARES = 2,
  DEBTS = 3,
  INCENTIVE_POOL = 4,
  STAKEHOLDERS = 5,
  SECURITY_PLANS = 6,
  DOCUMENT_SETS = 7,
  VALUATIONS = 8,
}

export type StatisticsData = BaseStatisticsData & {
  debt: DebtStatistics
}

export interface StatisticsQuantity {
  authorized: number
  outstanding: number
  deferred: number
  exercised: number
  available: number
  total: number
}

export interface StatusItem {
  id: number
  itemable_id: number
  can_transition: boolean
  completed: boolean
  status: StatusItemStatus
}

export interface StatusItems {
  values: IndexStatusItem[]
  total_count: number
}

export enum StatusItemStatus {
  INCOMPLETE = 0,
  COMPLETE = 1,
}

export interface Subscription {
  account_status: AccountStatus
  account_status_reason: AccountStatusReason
  pricing_package: SubscriptionPricingPackage
  juridical_person_category: JuridicalPersonCategory
  period_type: SubscriptionPeriodType
  start_date: string
  end_date: string
  renewal_date: string
  trial_end_date: string
  currency: Currency
  assisted_onboarding: boolean
  billing_customer_id: number
  billing_email: string
  comment: string
  company_name: string
  contract_length_in_months: number
  country: string
  discount: string
  id: number
  onboarding_price: string
  partner_code: string
  price: string
  renewal_price_per_stakeholder: string
  registration_number: string
  stakeholder_limit: number
  stripe_client_url: string
  stripe_id: string
  stripe_subscription_url: string
  stripe_url: string
  subscription_id: string
  subscription_stripe_id: string
  tax_country: string
  vat_number: string
}

export enum SubscriptionPeriodType {
  MONTHLY = 1,
  YEARLY = 2,
  CUSTOM = 3,
  UPFRONT_PAYMENT = 4,
  QUARTERLY = 5,
  SEMI_ANNUALLY = 6,
}

export enum SubscriptionPricingPackage {
  BUILD = 0,
  GROW = 1,
  SCALE = 2,
  RAISE = 3,
  CAPDESK_SUBSCRIPTION = 99,
}

export type Subscriptions = Subscription[]

export enum SystemMailType {
  RENEWALS_PING = -10,
  EMAIL_VERIFICATION = 0,
  RESET_PASSWORD = 1,
  WELCOME_EMAIL = 2,
  NEW_ADMINISTRATOR_INVITATION = 3,
  EXISTING_USER_ADMINISTRATOR_INVITATION = 4,
  NEW_USER_INVESTOR_ACCESS_INVITATION = 5,
  EXISTING_USER_INVESTOR_ACCESS_INVITATION = 6,
  UNREGISTERED_PERSON_OPTIONHOLDER_PUBLISH_INVITATION = 7,
  REGISTERED_PERSON_OPTIONHOLDER_PUBLISH_INVITATION = 8,
  REINVITE = 9,
  REPORT_CONFIRMATION = 10,
  REPORT_ERROR = 11,
  NOT_LIVE = 12,
  SYSTEM_COMPANY_INVITATION = 13,
  SYSTEM_COMPANY_TROUBLESHOOT = 14,
  NEW_USER_INVESTOR_PUBLISH_INVITATION = 15,
  EXISTING_USER_INVESTOR_PUBLISH_INVITATION = 16,
  NEW_COMPANY_INVESTOR_PUBLISH_INVITATION = 17,
  EXISTING_COMPANY_INVESTOR_PUBLISH_INVITATION = 18,
  REGISTERED_COMPANY_WARRANTHOLDER_PUBLISH_INVITATION = 20,
  REGISTERED_PERSON_WARRANTHOLDER_PUBLISH_INVITATION = 21,
  REGISTERED_COMPANY_RSUHOLDER_PUBLISH_INVITATION = 24,
  REGISTERED_PERSON_RSUHOLDER_PUBLISH_INVITATION = 25,
  UNREGISTERED_COMPANY_RSUHOLDER_PUBLISH_INVITATION = 26,
  UNREGISTERED_PERSON_RSUHOLDER_PUBLISH_INVITATION = 27,
  UNREGISTERED_COMPANY_WARRANTHOLDER_PUBLISH_INVITATION = 30,
  UNREGISTERED_PERSON_WARRANTHOLDER_PUBLISH_INVITATION = 31,
  NEW_VIEWER_INVITATION = 40,
  EXISTING_USER_VIEWER_INVITATION = 41,
  INVESTOR_EIS3_EMAIL = 50,
  NEW_COMPANY_INVESTOR_ACCESS_INVITATION = 51,
  INVESTOR_SEIS3_EMAIL = 52,
  MERGE_STAKEHOLDER = 60,
  EXISTING_COMPANY_INVESTOR_ACCESS_INVITATION = 61,
  ACCEPT_MERGE_STAKEHOLDER = 62,
  ACCEPTED_STAKEHOLDER_MERGE = 63,
  REJECTED_STAKEHOLDER_MERGE = 64,
  UNREGISTERED_COMPANY_OPTIONHOLDER_PUBLISH_INVITATION = 71,
  REGISTERED_COMPANY_OPTIONHOLDER_PUBLISH_INVITATION = 81,
  REGISTERED_COMPANY_DEBTHOLDER_PUBLISH_INVITATION = 100,
  REGISTERED_PERSON_DEBTHOLDER_PUBLISH_INVITATION = 101,
  UNREGISTERED_COMPANY_DEBTHOLDER_PUBLISH_INVITATION = 110,
  UNREGISTERED_PERSON_DEBTHOLDER_PUBLISH_INVITATION = 111,
  GO_LIVE_NOTIFICATION = 119,
  NEW_USER_COMPANY_CONSENT = 120,
  EXISTING_USER_COMPANY_CONSENT = 121,
  INTERNAL_CONSENT_NOTIFICATION = 123,
  INTERNAL_GO_LIVE_NOTIFICATION = 125,
  INTERNAL_COMPANY_DELETED_NOTIFICATION = 126,
  ORDER_REMINDER = 127,
  ORDER_CANCELLED_NOTIFICATION = 128,
  INTERNAL_COMPANY_OVERDUE_INVOICES_NOTIFICATION = 129,
  REGISTERED_COMPANY_PHANTOMSHAREHOLDER_ACCESS_INVITATION = 130,
  REGISTERED_PERSON_PHANTOMSHAREHOLDER_ACCESS_INVITATION = 131,
  REGISTERED_COMPANY_PHANTOMSHAREHOLDER_PUBLISH_INVITATION = 132,
  REGISTERED_PERSON_PHANTOMSHAREHOLDER_PUBLISH_INVITATION = 133,
  INTERNAL_REQUEST_ACCOUNT_ACTIVATION_NOTIFICATION = 134,
  UNREGISTERED_COMPANY_PHANTOMSHAREHOLDER_ACCESS_INVITATION = 140,
  UNREGISTERED_PERSON_PHANTOMSHAREHOLDER_ACCESS_INVITATION = 141,
  UNREGISTERED_COMPANY_PHANTOMSHAREHOLDER_PUBLISH_INVITATION = 142,
  UNREGISTERED_PERSON_PHANTOMSHAREHOLDER_PUBLISH_INVITATION = 143,
  REGISTERED_PERSON_PHANTOMSHAREHOLDER_ISSUANCE_INVITATION = 145,
  REGISTERED_COMPANY_PHANTOMSHAREHOLDER_ISSUANCE_INVITATION = 146,
  UNREGISTERED_PERSON_PHANTOMSHAREHOLDER_ISSUANCE_INVITATION = 147,
  UNREGISTERED_COMPANY_PHANTOMSHAREHOLDER_ISSUANCE_INVITATION = 148,
  EXERCISE_INVITATION = 157,
  EXERCISE_REQUEST_CONFIRMATION = 158,
  EXERCISE_COMPLETED_CONFIRMATION = 159,
  TERMINATION_CANCELLATION = 160,
  UNREGISTERED_PERSON_OPTIONHOLDER_ISSUANCE_INVITATION = 170,
  UNREGISTERED_COMPANY_OPTIONHOLDER_ISSUANCE_INVITATION = 171,
  REGISTERED_PERSON_OPTIONHOLDER_ISSUANCE_INVITATION = 180,
  REGISTERED_COMPANY_OPTIONHOLDER_ISSUANCE_INVITATION = 181,
  NEW_USER_INVESTOR_ISSUANCE_INVITATION = 190,
  NEW_COMPANY_INVESTOR_ISSUANCE_INVITATION = 191,
  EXISTING_USER_INVESTOR_ISSUANCE_INVITATION = 192,
  EXISTING_COMPANY_INVESTOR_ISSUANCE_INVITATION = 193,
  UNSUBSCRIBED = 200,
  REGISTERED_COMPANY_WARRANTHOLDER_ISSUANCE_INVITATION = 220,
  REGISTERED_PERSON_WARRANTHOLDER_ISSUANCE_INVITATION = 221,
  UNREGISTERED_COMPANY_WARRANTHOLDER_ISSUANCE_INVITATION = 230,
  UNREGISTERED_PERSON_WARRANTHOLDER_ISSUANCE_INVITATION = 231,
  REGISTERED_COMPANY_RSUHOLDER_ISSUANCE_INVITATION = 240,
  REGISTERED_PERSON_RSUHOLDER_ISSUANCE_INVITATION = 250,
  UNREGISTERED_COMPANY_RSUHOLDER_ISSUANCE_INVITATION = 260,
  UNREGISTERED_PERSON_RSUHOLDER_ISSUANCE_INVITATION = 270,
  SECURITY_ACCEPTANCE_REMINDER1 = 301,
  SECURITY_ACCEPTANCE_REMINDER5 = 302,
  SECURITY_ACCEPTANCE_REMINDER10 = 303,
  SECURITY_ACCEPTANCE_REMINDER20 = 304,
  SECURITY_ACCEPTANCE_REMINDER30 = 305,
  SECURITY_ACCEPTANCE_REMINDER90 = 306,
  EMPLOYEE_OFFBOARDING = 307,
  EMPLOYEE_OFFBOARDING_CANCELLED = 308,
  EMPLOYEE_OFFBOARDING_ACCOUNT_RETENTION = 309,
  STAKEHOLDER_SYNC_EMAIL = 400,
  STAKEHOLDER_ADD_SECONDARY_EMAIL_NUDGE = 600,
  NUDGE_COMPANY_SETUP_ITEM_EMAIL = 601,
  NOTIFY_ABOUT_ONBOARDING_DATA_UPLOAD = 602,
  NOTIFY_COMPANY_SETUP_ITEM_DUE_DATE_CHANGE = 603,
  LIQUIDITY_EVENT_INVITATION = 700,
  LIQUIDITY_EVENT_EXERCISE_NOTICE = 701,
  LIQUIDITY_EVENT_PREPARATION = 702,
  LIQUIDITY_EVENT_SIGNING_TASK = 703,
  LIQUIDITY_EVENT_ORDER_PLACEMENT = 704,
  LIQUIDITY_EVENT_ORDER_COMPLETION = 705,
  LIQUIDITY_EVENT_ORDER_CANCELLATION = 706,
  LIQUIDITY_EVENT_ORDER_CLEARING = 707,
  LIQUIDITY_EVENT_ORDER_SETTLED = 708,
  LIQUIDITY_EVENT_SALES_WINDOW_CLOSED = 709,
  LIQUIDITY_EVENT_PURCHASE_WINDOW_CLOSED = 710,
  LIQUIDITY_EVENT_PARTICIPATION_REVOKED = 711,
  OPEN_TASKS_DIGEST = 800,
  OPEN_TASKS_DIGEST_NON_USERS = 810,
  REGISTERED_COMPANY_OPTIONHOLDER_PUBLISH_GRANT = 811,
  REGISTERED_PERSON_OPTIONHOLDER_PUBLISH_GRANT = 812,
  UNREGISTERED_COMPANY_OPTIONHOLDER_PUBLISH_GRANT = 813,
  UNREGISTERED_PERSON_OPTIONHOLDER_PUBLISH_GRANT = 814,
  REGISTERED_COMPANY_WARRANTHOLDER_PUBLISH_GRANT = 815,
  REGISTERED_PERSON_WARRANTHOLDER_PUBLISH_GRANT = 816,
  UNREGISTERED_COMPANY_WARRANTHOLDER_PUBLISH_GRANT = 817,
  UNREGISTERED_PERSON_WARRANTHOLDER_PUBLISH_GRANT = 818,
  REGISTERED_COMPANY_PHANTOMSHAREHOLDER_PUBLISH_GRANT = 823,
  REGISTERED_PERSON_PHANTOMSHAREHOLDER_PUBLISH_GRANT = 824,
  UNREGISTERED_COMPANY_PHANTOMSHAREHOLDER_PUBLISH_GRANT = 825,
  UNREGISTERED_PERSON_PHANTOMSHAREHOLDER_PUBLISH_GRANT = 826,
  REGISTERED_COMPANY_RSUHOLDER_PUBLISH_GRANT = 827,
  REGISTERED_PERSON_RSUHOLDER_PUBLISH_GRANT = 828,
  UNREGISTERED_COMPANY_RSUHOLDER_PUBLISH_GRANT = 829,
  UNREGISTERED_PERSON_RSUHOLDER_PUBLISH_GRANT = 830,
  NEW_TERMINATION_GRANT = 833,
  EXISTING_TERMINATION_GRANT = 834,
  REGISTERED_COMPANY_DEBTHOLDER_PUBLISH_GRANT = 835,
  REGISTERED_PERSON_DEBTHOLDER_PUBLISH_GRANT = 836,
  UNREGISTERED_COMPANY_DEBTHOLDER_PUBLISH_GRANT = 837,
  UNREGISTERED_PERSON_DEBTHOLDER_PUBLISH_GRANT = 838,
  OPTIONHOLDER_TRUST_INVITATION = 839,
  WARRANTHOLDER_TRUST_INVITATION = 840,
  PHANTOMSHAREHOLDER_TRUST_INVITATION = 841,
  RSUHOLDER_TRUST_INVITATION = 842,
  DEBTHOLDER_TRUST_INVITATION = 843,
  INVESTOR_TRUST_INVITATION = 844,
  ORDER_SUMMARY = 845,
  STAKEHOLDER_SHARE_TRANSACTION_HAS_BEEN_EDITED = 846,
  GRANT_HAS_BEEN_EDITED = 847,
  DEBT_HAS_BEEN_EDITED = 848,
  CLEARING_TASK = 850,
  EMPLOYEE_PASSED_VESTING_CLIFF = 890,
  TWO_FACTOR_AUTHENTICATION_DISABLED_EMAIL = 900,
  EMPLOYEE_VESTED_50_PERCENT = 901,
  EMPLOYEE_VESTED_75_PERCENT = 902,
  EMPLOYEE_VESTED_100_PERCENT = 903,
  SECURITIES_VALUE_CHANGED = 910,
  EQUITY_SUMMARY = 911,
  VALUATION_REQUEST_CLIENT_LIVE_AND_SUBSCRIBED_CONFIRMATION_EMAIL = 1001,
  VALUATION_REQUEST_CLIENT_NOT_LIVE_OR_SUBSCRIBED_CONFIRMATION_EMAIL = 1002,
  VALUATION_REQUEST_CLIENT_FEATURE_ON_NOT_LIVE_OR_SUBSCRIBED_CONFIRMATION_EMAIL = 1003,
  VALUATION_EXPIRING_EMAIL = 1004,
  VALUATION_REQUEST_PENDING_CLIENT_APPROVAL_EMAIL = 1005,
  VALUATION_REQUEST_APPROVED_BY_CLIENT_EMAIL = 1006,
  VALUATION_REQUEST_HMRC_ACCEPTANCE_LETTER_DELIVERED_EMAIL = 1007,
  INTERNAL_VALUATION_REQUEST_APPROVED_EMAIL = 1009,
  INTERNAL_VALUATION_REQUEST_RECEIVED_EMAIL = 1010,
  VALUATION_REQUEST_GROWTH_SHARES_REPORT_DELIVERED_EMAIL = 1011,
  VALUATION_REQUEST_VAL231_REPORT_PENDING_SIGNATURE_EMAIL = 1012,
  VALUATION_REQUEST_VAL231_REPORT_SIGNED_EMAIL = 1013,
  INTERNAL_VALUATION_REQUEST_VAL231_SIGNED_EMAIL = 1014,
  VALUATION_IN_PROGRESS_EMAIL = 1015,
  VALUATION_AUTO_CANCELLATION_EMAIL = 1016,
  VALUATION_COMPLETE_DATA_COLLECTION_RE_ENGAGEMENT_EMAIL = 1017,
  STAKEHOLDER_CLAIM_COMPANY_INVITATION = 1100,
  INVESTOR_CLAIM_COMPANY_INVITATION = 1101,
  REQUEST_TRANSACTION_DETAILS_CHANGES_ISSUER = 1201,
  REQUEST_TRANSACTION_DETAILS_CHANGES_REQUESTER = 1202,
  REQUEST_HOLDING_COMPANY_DETAILS_CHANGES_ISSUER = 1203,
  REQUEST_HOLDING_COMPANY_DETAILS_CHANGES_REQUESTER = 1204,
  REQUEST_HOLDING_COMPANY_ADMIN_ACCESS_REQUESTER = 1205,
  REQUEST_HOLDING_COMPANY_ADMIN_ACCESS_REQUESTEE = 1206,
  INTERNAL_EXPENSE_REPORT_NEW_REQUEST_EMAIL = 1301,
  INTERNAL_EXPENSE_REPORT_REQUEST_APPROVED_EMAIL = 1302,
  EXPENSE_REPORT_UPLOADED_EMAIL = 1303,
  SH01_FILING_SUBMITTED_TO_COMPANIES_HOUSE_EMAIL = 1401,
  SH01_FILING_ACCEPTED_EMAIL = 1402,
  SH01_FILING_REJECTED_EMAIL = 1403,
  REQUEST_COMPANY_FEATURE = 1500,
  REQUEST_PLAN_UPGRADE_EMAIL = 1501,
  DEBT_ISSUANCE_REVIEW_AND_SIGN_EMAIL = 1600,
  NEW_EXTERNAL_ADMINISTRATOR_INVITATION = 1700,
  EXISTING_EXTERNAL_ADMINISTRATOR_INVITATION = 1701,
  EXTERNAL_ADMINISTRATOR_INVITATION_REMINDER = 1702,
  EXTERNAL_ADMINISTRATOR_INVITATION_FINAL_REMINDER = 1703,
  CS01_FILED = 1800,
  CS01_ACCEPTED = 1801,
  CS01_REJECTED = 1802,
  CS01_FILING_DEADLINE = 1803,
  AP01_FILED = 1810,
  AP01_ACCEPTED = 1811,
  AP01_REJECTED = 1812,
  AP02_FILED = 1813,
  AP02_ACCEPTED = 1814,
  AP02_REJECTED = 1815,
  AP03_FILED = 1816,
  AP03_ACCEPTED = 1817,
  AP03_REJECTED = 1818,
  AP04_FILED = 1819,
  AP04_ACCEPTED = 1820,
  AP04_REJECTED = 1821,
  INTERNAL_ADVANCE_ASSURANCE_NEW_REQUEST_EMAIL = 1900,
  INTERNAL_ADVANCE_ASSURANCE_ASSIGNEE_CHANGED_EMAIL = 1901,
  INTERNAL_ADVANCE_ASSURANCE_REQUEST_APPROVED_BY_CLIENT_EMAIL = 1902,
  CUSTOMER_ADVANCE_ASSURANCE_NEW_REQUEST_EMAIL = 1903,
  CUSTOMER_ADVANCE_ASSURANCE_REQUEST_READY_FOR_APPROVAL_EMAIL = 1904,
  CUSTOMER_ADVANCE_ASSURANCE_REQUEST_SUBMITTED_TO_HMRC_EMAIL = 1905,
  CUSTOMER_ADVANCE_ASSURANCE_REQUEST_COMPLETED_EMAIL = 1906,
  CUSTOMER_ADVANCE_ASSURANCE_REQUEST_CANCELLED_EMAIL = 1907,
  INTERNAL_ADVANCE_ASSURANCE_NEW_DATA_UPLOADED_EMAIL = 1908,
  DEBT_CONVERSION_REMINDER = 2000,
  EXTERNAL_COMPANY_INELIGIBLE_FOR_AUTOMATED_ONBOARDING = 2100,
  INTERNAL_COMPANY_INELIGIBLE_FOR_AUTOMATED_ONBOARDING = 2101,
}

export interface Task {
  assigned_stakeholder?: AssignedStakeholder
  assigned_stakeholder_role: number
  assigned_name?: string | null
  assigned_email?: string | null
  company_id: number | null
  company_name: string | null
  created_at: string
  flow?: Flow
  id: number
  parent_assigned_stakeholder_role?: number
  signatures?: Signature[]
  status_value: TaskStatus
  type: TaskType | null
}

export interface Tasks {
  values: Task[]
  total_count: number
}

export enum TaskStatus {
  OPEN = 1,
  TRANSITIONED = 2,
  FAILED = 3,
  CANCELLED = 4,
}

export enum TaskType {
  STAKEHOLDER_MERGE_ACCEPTANCE = 'Actor::Stakeholder::Flow::MergeStakeholderAcceptanceTask',
  DOCUMENT_PROCESSING = 'Document::Flow::DocumentProcessingTask',
  DOCUMENT_SIGNATURE_COMPLETION = 'Document::Signature::Flow::CompletionTask',
  DOCUMENT_SIGNATURE_PUBLISH = 'Document::Signature::Flow::PublishTask',
  DOCUMENT_SIGNATURE_SIGNATORY_DETAILS = 'Document::Signature::Flow::SignatoryDetailsTask',
  DOCUMENT_SIGNATURE = 'Document::Signature::Flow::SignatureTask',
  REPORTING_FILING_EIS_CREATING_DOCUMENTS = 'Reporting::Filing::Tax::Gb::Eis::Flow::CreatingDocumentsTask',
  REPORTING_FILING_EIS_PUBLISH = 'Reporting::Filing::Tax::Gb::Eis::Flow::PublishTask',
  REPORTING_FILING_SEIS_CREATING_DOCUMENTS = 'Reporting::Filing::Tax::Gb::Seis::Flow::CreatingDocumentsTask',
  REPORTING_FILING_SEIS_PUBLISH = 'Reporting::Filing::Tax::Gb::Seis::Flow::PublishTask',
  DEBT_ISSUANCE_ORDER_APPROVAL = 'Security::Debt::Flow::IssuanceOrderApprovalTask',
  SECURITY_ACCEPTANCE = 'Security::Flow::AcceptanceTask',
  GRANT_CONVERSION_ORDER_APPROVAL = 'Security::Grant::Flow::ConversionOrderApprovalTask',
  LIQUIDITY_EVENT_FUNDING = 'Security::LiquidityEvent::Flow::CapdeskFundingTask',
  LIQUIDITY_EVENT_CLEARING_APPROVAL = 'Security::LiquidityEvent::Flow::ClearingApprovalTask',
  LIQUIDITY_EVENT_DOCUMENT_COPYING = 'Security::LiquidityEvent::Flow::DocumentCopyingTask',
  LIQUIDITY_EVENT_TRANSACTION_SET_COMPLETED = 'Security::LiquidityEvent::Flow::TransactionSetCompletedTask',
  LIQUIDITY_EVENT_TRANSACTIONS_FILED = 'Security::LiquidityEvent::Flow::TransactionsFiledTask',
  PAYMENT_AWAITING_SIGNING = 'Security::Payment::Flow::AwaitingSigningTask',
  PAYMENT_ESCROW_APPROVAL = 'Security::Payment::Flow::EscrowApprovalTask',
  PAYMENT_ESCROW_APPROVED = 'Security::Payment::Flow::EscrowApprovedTask',
  TRANSACTION_ORDER_EXECUTION_CANCELLATION_APPROVED = 'Security::Transaction::Flow::OrderExecutionCancellationApprovedTask',
  TRANSACTION_ORDER_EXECUTION_CANCELLATION_INITIATED = 'Security::Transaction::Flow::OrderExecutionCancellationInitiatedTask',
  TRANSACTION_ORDER_EXECUTION_CANCELLED = 'Security::Transaction::Flow::OrderExecutionCancelledTask',
  TRANSACTION_PUBLISH = 'Security::Transaction::Flow::PublishTask',
  TRANSACTION_SCHEDULE_PUBLISH = 'Security::Transaction::Flow::SchedulePublishTask',
}

export interface TaxInformation {
  tin_reason?: NoTinReason | null
  outside_residency_reason?: OutsideResidencyReason | null
  id?: number
  country: string
  tin?: string | null
  tin_description?: string | null
  outside_residency_description?: string | null
}

export enum TerminationCancellationRule {
  UNCONFIGURED = 0,
  KEEP_VESTED = 1,
  CANCEL_ALL = 2,
  CONVERT_TO_ANOTHER_SHARE_CLASS = 3,
  TRANSFER_SHARES_TO_ANOTHER_ENTITY = 4,
}

export interface TerminationRule {
  period_type: PlanPeriodType
  id: number
  name: string
  period_count: number
  _newId?: number
  _destroy?: boolean
}

export enum TerminologySettingDefaults {
  exercise_price_naming = 'exercise_price',
  phantom_share_naming = 'phantom_share',
}

export interface TerminologySettings {
  phantom_share_naming: PhantomShareNames
  exercise_price_naming: ExercisePriceNames
}

export enum TerminologySettingType {
  EXERCISE_PRICE_NAMING = 'exercise_price_naming',
  PHANTOM_SHARE_NAMING = 'phantom_share_naming',
}

export enum TransactionCancellationReason {
  CONVERSION = 0,
  BUYBACK = 2,
  EXPIRATION = 3,
  SHARE_CAPITAL_VARIATION = 4,
  DEATH = 5,
  DISABILITY = 6,
  LEAVE_INVOLUNTARILY = 7,
  LEAVE_VOLUNTARILY = 8,
  SHARE_CLASS_CONVERSION = 10,
  RELEASE = 11,
  SURRENDER = 12,
  TERMINATION = 13,
  TRANSFER = 14,
  OTHER = 99,
}

export interface TransactionCompany {
  id: number
  company_name: string
  email: string
  country: string
  cosec_activation_v3_enabled: boolean
  config_share_certificates_enable: boolean
  thumbnail?: string
}

export enum TransactionExecutionType {
  OFFLINE = 0,
  ONLINE = 1,
}

export enum TransactionOrigin {
  LEGACY_CONSOLIDATION = -1001,
  LEGACY_SUBDIVISION = -1000,
  STANDARD = 0,
  EXERCISE = 1,
  SUBDIVISION = 3,
  CONSOLIDATION = 4,
  CONVERSION = 5,
  SHARE_GRANT_ISSUANCE = 6,
  SHARE_GRANT_CANCELLATION = 7,
  OFFBOARDING = 8,
  ONBOARDING = 9,
  TERMINATION = 10,
  AUTOMATION = 11,
  DEBT_TRANSFER = 12,
}

export interface TransactionRequest {
  description_summary?: string
  max_quantity?: string
  price?: string
  quantity?: string
  conversion_price?: string
  request_execution_type?: RequestExecutionType
}

export type TransactionSet = TransactionSetLight & {
  processable_processing_status?: ProcessableProcessingStatus
  processable_result?: ProcessableResult
  statistics?: TransactionSetStatistics
  title?: string
  company_id?: number
  title_with_extension?: string
  processable_processing_start?: string
  processable_processing_end?: string
  has_online_issuances?: boolean
  processable_file?: string
  processable_file_file_name?: string
  processable_file_content_type?: string
}

export interface TransactionSetLight {
  id: number
  type: TransactionSetType
  created_at: string
}

export interface TransactionSetStatistics {
  num_draft?: number
  num_published?: number
  num_in_progress?: number
  max_published_date?: string
}

export enum TransactionSetType {
  DEBT_TRANSACTION_SET = 'Security::Debt::DebtTransactionSet',
  OPTION_TRANSACTION_SET = 'Security::Option::OptionTransactionSet',
  PHANTOM_SHARE_TRANSACTION_SET = 'Security::PhantomShare::PhantomShareTransactionSet',
  RSU_TRANSACTION_SET = 'Security::Rsu::RsuTransactionSet',
  SHARE_GRANT_TRANSACTION_SET = 'Security::Share::ShareGrantTransactionSet',
  SHARE_TRANSACTION_SET = 'Security::Share::ShareTransactionSet',
  WARRANT_TRANSACTION_SET = 'Security::Warrant::WarrantTransactionSet',
}

export interface TransactionShareClass {
  id: number
  name: string
  nominal_value: number
  nominal_value_currency?: Currency
}

export enum TransactionType {
  ISSUANCE = 0,
  TRANSFER = 1,
  CANCELLATION = 2,
  CONVERSION = 3,
}

export interface TwoFactorAuthentication {
  expires_at?: string
  created_at?: string
  sms_dispatches?: SmsDispatch[]
  id: number
  attempts?: number
}

export interface TwoFactorAuthenticationBackupCodesResponse {
  backup_codes: string[]
}

export enum TwoFactorMethod {
  SMS = 0,
  AUTHENTICATOR = 2,
}

export interface UpdateWitnessInfoParams {
  witness_name: string
  witness_email: string
}

export interface Usage {
  admins?: UsageType
  stakeholders_total?: UsageType
  vehicle_stakeholders?: UsageType
  stakeholders?: StakeholderUsageType
  total?: UsageType
}

export interface UsageType {
  active: number
  all: number
}

export interface User {
  verification_status: VerificationStatus
  omniauth_authorization_provider?: OmniauthAuthorizationProvider
  feature_flag_user: FeatureFlagUser
  actor_verification?: ActorVerification
  metadata?: Metadata
  offboarding_stakeholders: OffboardingStakeholder[]
  emails: Email[]
  draft_modes: DraftMode[]
  tax_informations?: TaxInformation[]
  created_at: string
  updated_at: string
  last_login_at: string
  id: number
  about?: string
  allow_emails: boolean
  country?: string
  date_of_birth?: string
  first_name: string
  dial_code: string
  gender?: string
  is_public: boolean
  middle_name?: string
  last_name: string
  legal_name: string
  occupation: string
  email: string
  phone_number?: string
  personal_id?: string
  address1: string
  address2: string
  postcode: string
  city: string
  region: string
  seller_document_upload_url?: string
  requires_seller_document_upload?: boolean
  intercom_hash: string
  open_tasks_count: number
  open_securities_related_tasks_count: number
  open_transaction_acceptance_tasks_count: number
  open_certificate_acceptance_tasks_count: number
  display_country: string
  display_country_name: string
  thumbnail: string
  photo_exists: boolean
  is_complete: boolean
  need_terms_consent: boolean
  is_staff_user: boolean
  is_staff_admin: boolean
  is_staff_support: boolean
  escrow_transaction_enabled: boolean
  in_active_liquidity_event?: boolean
  is_employee?: boolean
  is_investor?: boolean
  is_admin?: boolean
  is_equity_management_admin?: boolean
  is_2fa_enabled: boolean
  need_to_enable_2fa?: boolean
  is_2fa_required: boolean
  calendar_book_url: string
  is_external?: boolean
  is_implementation_manager: boolean
  is_implementation_manager_assigned_to_company?: boolean
  is_valuation_analyst: boolean
  must_logout?: boolean
  sms_2fa_enabled?: boolean
  authenticator_2fa_enabled?: boolean
  show_investor_data?: boolean
  show_employee_data?: boolean
  show_portfolio?: boolean
  trust_device_duration_days?: number
  latest_display_currencies: string[]
  administered_company_ids?: number[]
  default_currency: Currency
  company_id_pending_onboarding: number | null
  admin_of_company_with_equity_grants: boolean
  migrated_to_cw: boolean
}

export type UserAdminArea = User & {
  actor_verifications?: ActorVerification[]
  two_factor_authentications?: TwoFactorAuthentication[]
  stakeholders?: StakeholderInCompany[]
}

export interface Valuation {
  created_at: string
  expires_at?: string
  valuated: string
  type: ValuationType
  registered?: string
  updated_at?: string
  financial_model?: FinancialModel
  documents?: Document[]
  id: number
  is_active: boolean
  price?: number
  valid_for?: number
  share_class_id?: number
  share_class_name?: string
  depreciable: boolean
  has_soft_links: boolean
  is_soft_link?: boolean
  authority_reference?: string
  description?: string
  creator?: string
  updater?: string
  dividend_yield?: number
  exercise_price?: number
  expiration?: number
  interest_rate?: number
  jurisdiction?: string
  no_soft_link?: boolean
  note?: string
  spot_price?: number
  volatility?: number
  is_draft: boolean
  valuation_request_id?: number
  price_currency?: Currency
  spot_price_currency?: Currency
  exercise_currency?: Currency
}

export interface Valuation231PutParams {
  total_number_shares: number
  has_shares_allotted: boolean
  particulars_shares_allotted?: string
  has_transactions_within_year: boolean
  particulars_transactions_within_year?: string
  dividends_been_paid: boolean
  particulars_dividends_paid?: string
  has_prospect_for_sale: boolean
  details_prospect_for_sale?: string
  has_prospect_of_flotation: boolean
  details_prospect_of_flotation?: string
}

export interface ValuationAnalyst {
  id: number
  legal_name: string
  email: string
}

export enum ValuationCalculationMethod {
  PUBLIC_SHARE = 0,
  SHARE_CLASS = 1,
}

export interface ValuationCount {
  id: string
  value: number
}

export interface ValuationPostParams {
  type: ValuationType
  valuated: string
  registered?: string | null
  financial_model?: FinancialModel
  documents_attributes?: DocumentAttributes[]
  price_currency?: Currency
  spot_price_currency?: Currency
  price?: number
  dividend_yield?: number
  spot_price?: number
  interest_rate?: number
  volatility?: number
  id?: number
  jurisdiction: string
  share_class_id: number
  authority_reference?: string | null
  note?: string | null
  valid_for?: number | null
}

export interface ValuationPutParams {
  financial_model?: FinancialModel
  registered?: string | null
  documents_attributes?: DocumentAttributes[]
  price_currency?: Currency
  spot_price_currency?: Currency
  price?: number
  dividend_yield?: number
  spot_price?: number
  interest_rate?: number
  volatility?: number
  is_active?: boolean
  authority_reference?: string | null
  note?: string | null
}

export interface ValuationRequest {
  completed_at?: string
  requested_at: string
  status: ValuationRequestStatus
  valuation_request_type: ValuationRequestType
  expect_financing?: ValuationRequestFinancingType
  option_scheme?: ValuationRequestOptionScheme
  financial_expectation_status?: FinancialExpectationStatus
  cash_runway_length?: CashRunway
  available_transitions: ValuationRequestStatus[]
  valuations?: Valuation[]
  company: {
    articles_of_association?: Document
    id: number
    company_name: string
    account_status: number
    feature_enabled: boolean
    billing_customer_id: number
  }
  assignee?: {
    id: number
    name: string
    email?: string
  }
  id: number
  requested_by?: string
  contact_email: string
  valuation_report_url?: string
  hmrc_acceptance_letter_url?: string
  valuation_report_name?: string
  val231_report_url?: string
  val231_report_name?: string
  flowable_status?: number
  exclude_draft_transactions?: boolean
  options_been_granted_before?: boolean
  estimated_number_of_grants?: number
  estimated_number_of_grantholders?: number
  granting_above_ten_percent?: boolean
  from_valuation_date?: string
  report_currency?: string
  company_updates?: string
  financial_data?: Record<string, unknown>
  expect_liquidity?: boolean
  dividends_paid?: boolean
  notes?: string
  expectations?: string
  data_collected_at?: string
  step?: number
  financial_information_currency?: string
  share_class_id?: number
  has_consented?: boolean
}

export enum ValuationRequestFinancingType {
  UNPRICED_INVESTMENTS = 0,
  PRICED_INVESTMENTS = 1,
}

export enum ValuationRequestOptionScheme {
  EMI = 0,
  CSOP = 1,
}

export interface ValuationRequestPostParams {
  valuation_request_type: ValuationRequestType
  company_id: number
}

export interface ValuationRequestPutParams {
  status?: ValuationRequestStatus
  valuation_report?: Blob | File
  cancellation_reason?: string
  assignee_id?: number
}

export enum ValuationRequestStatus {
  IN_PROGRESS = 1,
  COMPLETED = 2,
  CANCELLED = 3,
  PENDING = 4,
  RECEIVED = 5,
  PENDING_CLIENT_APPROVAL = 6,
  READY_FOR_HMRC = 7,
  HMRC_REVIEW = 8,
  ABANDONED = 9,
  PENDING_DATA = 10,
}

export enum ValuationRequestType {
  EMI_CSOP = 0,
  US_409A = 1,
  GROWTH_SHARES = 2,
  OTHER = 3,
}

export interface ValuationRequestUploadGrowthSharesReportPutParams {
  valuation_report: Blob | File
}

export interface ValuationRequestUploadLetterPutParams {
  hmrc_acceptance_letter: Blob | File
  valuated: string
  valid_for: number
  amv_price: number
  umv_price: number
}

export interface ValuationsParams {
  id: number
  valuations: ValuationPostParams[]
}

export interface ValuationStage {
  max_valuation_in_usd: number
  stage_in_user_default_currency: number[]
}

export interface ValuationStatistics {
  counts: {
    gb_amv: ValuationCount
    gb_umv: ValuationCount
    us409a: ValuationCount
    fair_value: ValuationCount
    share_price: ValuationCount
  }
}

export enum ValuationType {
  GB_AMV = 'Security::Valuation::CountryLogic::GbAmv',
  GB_UMV = 'Security::Valuation::CountryLogic::GbUmv',
  US409A = 'Security::Valuation::CountryLogic::Us409a',
  FAIR_VALUE = 'Security::Valuation::FairValue',
  SHARE_PRICE = 'Security::Valuation::SharePrice',
}

export enum ValuationTypeWithCombinedAmvUmv {
  GB_AMV = 'Security::Valuation::CountryLogic::GbAmv',
  GB_AMV_UMV = 'Security::Valuation::CountryLogic::GbAmvUmv',
  GB_UMV = 'Security::Valuation::CountryLogic::GbUmv',
  US409A = 'Security::Valuation::CountryLogic::Us409a',
  FAIR_VALUE = 'Security::Valuation::FairValue',
  SHARE_PRICE = 'Security::Valuation::SharePrice',
}

export enum VehicleType {
  TRUST = 1,
  NOMINEE = 2,
}

export enum VerificationStatus {
  NOT_STARTED = 0,
  SUCCEEDED = 1,
  EXPIRED = 2,
  INVALIDATED = 3,
}

export interface VerifyTwoFactorAuthenticationPostParams {
  method: TwoFactorMethod
  code: string
  is_enabling?: boolean
}

export interface Version {
  author?: VersionAuthor
  event: VersionEvent
  id: number
  created_at: string
  item_id: number
  item_type: string
  object_changes: Record<string, unknown>
  object: Record<string, unknown>
  metadata: Record<string, unknown>
}

export interface Versionable {
  id?: number
  type?: string
  transactioned?: string
  published?: string
  company_name?: string
  transaction_type?: number
  legal_name?: string
  stakeholder_name?: string
  company_id: number
  has_full_list_of_versions: boolean
  security_grant_id?: number
  valuation_type?: string
  versioned_from?: string
}

export interface VersionAuthor {
  id: number
  legal_name: string
}

export enum VersionEvent {
  CREATE = 'create',
  DESTROY = 'destroy',
  UPDATE = 'update',
}

export interface Versions {
  values: Version[]
  total_count: number
}

export enum VestingOn {
  FIRST_OF_MONTH = 0,
  SAME_DATE = 1,
  LAST_OF_MONTH = 2,
}

export interface VestingSchedule {
  cliff_percentage: string | null
  grant_id?: number
  id: number
  source_vesting_type: VestingType
  vesting_cliff: number | null
  vesting_description: string | null
  vesting_description_custom: string | null
  vesting_interval: number | null
  vesting_months: number | null
  vesting_on: VestingOn | null
  vesting_start: string
  vesting_start_adjustment_type: VestingStartAdjustmentType
  vesting_type: VestingType
  non_linear_periods?: Array<{
    interval: number
    percentage: number
    span: number
  }>
  vesting_tranches: Array<{
    condition: string | null
    date: string | null
    id: number
    is_cancellation_condition_tranche: boolean
    is_market_condition: boolean | null
    pause_end_date: string | null
    scheduled_quantity: string
    vested_quantity: string | null
  }>
}

export enum VestingStartAdjustmentType {
  NONE = 0,
  ONLINE_EXECUTION = 1,
}

export enum VestingType {
  TIME_BASED_EQUAL_ROUND_UP = 0,
  CUSTOM = 1,
  IMMEDIATE = 2,
  TIME_BASED_ROUND_UP = 3,
  RECALCULATED_NON_CUSTOM = 4,
  TIME_BASED_EQUAL_ROUND_DOWN = 5,
  PERFORMANCE_BASED = 6,
  TIME_BASED_ROUND_DOWN = 7,
  TIME_BASED_FRACTIONAL = 8,
  TIME_BASED_NON_LINEAR_ROUND_UP = 9,
  TIME_BASED_NON_LINEAR_ROUND_DOWN = 10,
}

export interface WarrantStatistics {
  counts: {
    total: number
    online_count: number
    employment_related_count: number
    grant_count: IdValueSet
  }
  quantity: {
    outstanding: number
    total: number
    share_class: NameValueSet
  }
  votes: {
    outstanding?: number
    exercised: number
    total: number
  }
  cost?: {
    issued_outside_funding_round: number
  }
  transaction_quantity: {
    share_class: NameValueSet
  }
}

export enum WithdrawalRestriction {
  COURT_ORDER = 'COURT_ORDER',
  WITHDRAWAL_NOTICE = 'WITHDRAWAL_NOTICE',
}

export interface WitnessedSignature {
  id: number
  service_status: SignatureServiceStatus
}

export interface WitnessSignature {
  id: number
  stakeholder_appearance: string | null
  stakeholder_id: number | null
  service_status: SignatureServiceStatus
}
